/**
 * FirmaProjelerListPage.jsx — Projeler Listesi (Dekoratör görünümü, kart görünümü)
 * Route: /Firma/Projeler
 *
 * Bu dekoratör firmanın TÜM standlarının, her biri tek bir karta özetlenmiş
 * listesi — standOverviewService.getStandOverviewList'in decoratorFirmaId
 * filtresiyle döndürdüğü aynı stand kaydı (StandListPage.jsx'in "Liste"
 * görünümünde kullanılan standCategory/floorInfo/projectType/projectStructure/
 * standArea/projectHeightNumber + fileApprovals/commitments/revisions alanları)
 * FirmaTaleplerListPage.jsx'in kart diliyle (koyu salon/stand rozeti, ikon-kare
 * satırı, gri ayraçlarla gruplanmış kategoriler, "Detaylar" pill butonu) tekrar
 * kullanılıyor. Çoğunlukla salt okunur — satır aksiyonu var olan
 * FirmaStandDetailPage.jsx'e (/Firma/Anasayfa/:standId — "Proje Dosyaları" ve
 * "İnşa İzni ve Taahhütnameler" sekmeleri bu kartın gösterdiği aynı veriyi
 * zaten kapsıyor) yönlendirir. Tek istisna: standOverviewService'te henüz proje
 * bilgisi girilmemiş standlar (bkz. standId 326, projectDeclared: false) için
 * kart yerine "Proje Beyanı Yap" düğmesi + CreateProjectModal ("Proje Beyanı")
 * gösterilir — dekoratör Sınıflandırma (Proje Türü/Proje Yapısı/Proje Tipi) ve
 * zorunlu Ölçüler (H Max/Proje Alanı m²/kW) alanlarını, opsiyonel Teknik Talep
 * (Elektrik/Su/Hava/İnternet) deklarasyonunu ve opsiyonel kroki duvar
 * yüksekliklerini tek modalda girer (bkz. createStandProject/declareTeknikTalepler,
 * dosya sonundaki 2026-07-31 (Proje Beyanı) notu).
 *
 * Bilgi kutuları (Paket/Kat/Proje Tipi/Yapı/Alan/Yükseklik) durum takibi değil,
 * bu yüzden hep nötr gri — StandListPage.jsx'teki teal InfoPill'in aksine.
 * Proje Dosyaları ve Taahhütname kareleri FILE_APPROVAL_STATUS'e göre renklenir
 * (gri = kayıt yok, turuncu = beklemede, yeşil = onaylandı, kırmızı = reddedildi).
 * Sağdaki 4'lü sayaç setindeki "Revizyon İstendi" sayısı artık standOverviewService'in
 * (hiçbir yerde mutator'ı olmayan, ölü) stand.revisions alanını DEĞİL, projectService.js'teki
 * gerçek revizyon konuşmalarını kullanıyor — standId üzerinden köprülenip (bkz.
 * getProjectByStandId, 2026-07-18 eklendi) her stand için açık ('open') revizyon sayısı
 * hesaplanıyor. FirmaStandDetailPage.jsx'teki "Açık Revizyonlar" kartı aynı köprüyü kullanır.
 *
 * 2026-07-23 revizyonu: Proje Dosyaları ve Taahhütname ikon-kareleri (StatusTile)
 * artık tıklanabilir, FirmaStandDetailPage.jsx'e `?tab=files&kategori=<standFileId>`
 * / `?tab=commitments&kategori=<key>` ile yönlendirir (bkz. ProjeStatusTiles/
 * TaahhutnameTiles) — aynı desen FirmaPersonelListPage.jsx'teki StatusTile'da.
 * Bilgi kutuları (StandInfoGrid) durum takibi taşımadığı için bu kapsamın dışında
 * bırakıldı.
 *
 * 2026-07-31 revizyonu: stand rozetinin (StandThumbnail) arka planı artık sabit
 * koyu gri değil — bu standın İnşa İzni durumunu taşır (FirmaStandListPage.jsx'teki
 * StandStatusTiles'daki İnşa İzni karesiyle aynı izinVar kaynağı/formülü). Proje
 * bilgisi henüz yüklenmemiş standlarda (hasProject false) bu kavram anlamsız
 * olduğundan rozet nötr gri kalır.
 *
 * 2026-07-31 revizyonu (Proje Beyanı, /revise-page): "Proje Yükle" modalı "Proje
 * Beyanı" olarak yeniden adlandırıldı ve iki bölüme ayrıldı. (1) Sınıflandırma —
 * Stand Türü (standCategory, salt okunur — admin tarafından zaten atanmış, dekoratör
 * sadece görür), Proje Türü (floorInfo, artık serbest metin değil Tek Katlı/Çift Katlı
 * seçimi — bkz. FLOOR_INFO_OPTIONS; bu etiket kasıtlı olarak FirmaStandDetailPage.jsx'
 * teki "Proje Türü" ile ÇAKIŞIYOR — orada standTypeName/Ahşap-Metal gösterir, burada
 * floorInfo/Tek-Çift Katlı; kullanıcı bu ismi bilerek korumayı tercih etti), Proje
 * Yapısı (projectType — sadece Ahşap/Modüler seçilebilir, 'diger' artık yeni
 * deklarasyonlarda sunulmuyor, sadece önceden deklare edilmiş kayıtlarda gösterime
 * devam ediyor) ve ona bağlı Proje Tipi (projectStructure — Ahşap seçilirse mdf/sunta/
 * agac, Modüler seçilirse maxima/octonorm, bkz. PROJECT_STRUCTURE_BY_TYPE). (2)
 * Ölçüler — H Max değişmedi; ayrı En/Boy alanlarının yerini tek bir Proje Alanı (m²)
 * aldı (en/boy hiçbir yerde ayrı okunmuyordu, sadece standArea'yı türetmek için
 * kullanılıyordu, bkz. standOverviewService.createStandProject); eski Duvar Sayısı
 * dropdown'ı + genel H Duvar 1/2 alanlarının yerini krokideki 6 duvarın (kroki
 * MockKrokiShape/KrokiShape ile aynı sabit L şekli) her birine tıklayarak o duvarın
 * yüksekliğini giren interaktif WallDimensionsKroki aldı (bkz. wallHeights, sonradan
 * wallWidths ile genişletildi — bkz. aşağıdaki 2026-07-31 "duvar genişliği" notu).
 *
 * 2026-07-31 revizyonu (kW birleştirme + Sürdürülebilirlik): kW artık Ölçüler'de
 * AYRICA sorulmuyor — tek soru noktası Teknik Talepler'deki Elektrik kartı, ona
 * Su/Hava/İnternet'teki gibi bir switch eklendi ama onlardan farklı olarak varsayılan
 * AÇIK (elektrik neredeyse her stand için geçerli olduğundan) — kapatılırsa hem miktar
 * input'u disabled olur hem submit'te ne stand.kw'a (kart bilgi kutusu) ne Teknik
 * Talep'e gönderilir (bkz. handleSubmit'teki elektrikValue). Ayrıca, üstteki alanlar
 * (neredeyse her fuarda sorulur) ile görsel olarak ayrılmış, kesikli çerçeveli bir
 * Sürdürülebilirlik Beyanı bloğu eklendi — nadir kullanılacağı için; "Formu Doldur"
 * düğmesi yeni sekmede Saha tarafındaki mock/test formuna (/FdsSaha/Sustainability,
 * bkz. SustainabilityDeclarationForm.jsx) götürür, doldurulması Proje Beyanı'nın
 * tamamlanması için ŞART DEĞİL. O rotanın roles listesine dekoratör rolleri (9, 19)
 * eklendi — aksi halde bu bağlantı dekoratörü doğrudan login'e geri atardı (bkz.
 * allRoutes.js, AuthProtected.js'teki roles.includes(userGroupId) kontrolü).
 *
 * 2026-07-31 revizyonu (duvar genişliği): WallDimensionsKroki'deki (eski adıyla
 * WallHeightKroki) her duvar noktasına artık yükseklikten ÖNCE genişlik de soruluyor
 * — genişlik yükseklikten daha önemli kabul edildiği için hem input sırası hem
 * WALL_POSITIONS noktasına tıklandığında açılan panelin sırası buna göre. Ayrı bir
 * form.wallWidths haritası eklendi (form.wallHeights'ın birebir kopyası — bkz.
 * updateWallWidth/updateWallHeight), krokideki nokta genişlik VEYA yükseklik
 * girildiğinde dolu (teal) gösterilir. standOverviewService.createStandProject artık
 * wallWidths'i de wallHeights'la aynı şekilde (boş anahtarlar filtrelenip Number'a
 * çevrilerek) stand.wallWidths'e yazıyor.
 *
 * 2026-09-04 revizyonu (revizyon görünürlüğü + adlandırma):
 *  · "Özel İzin" katılımcıya gösterilen ADIYLA "Proje Yardım Merkezine İlet" oldu
 *    (rozetler, düğmeler, sihirbazdaki onay kutusu ve açıklama metinleri). Uç
 *    (POST /projects/{id}/ozel-izin), alan adları (ozelIzinBekliyor/ozelIzinli/
 *    ozelIzinNotu) ve denetmen tarafındaki "Özel İzinler" ekranı DEĞİŞMEDİ — bu
 *    yalnızca dekoratör ekranındaki kopya. Bkz. OzelIzinDurumu/OzelIzinTalepModal.
 *  · Açık revizyonu olan standın kartı artık bunu bağırıyor: gri bilgi kutularının
 *    hemen SOLUNDA büyük kırmızı ünlem kutusu (RevizyonUyarisi). Kaynağı sayaçla
 *    aynı — openRevisionCounts, yani kapanmamış (isRevisionUnfinished) revizyonlar.
 *  · Dört sayaç (Bekleyen/Revizyon istenen/Onaylanan/Reddedilen) artık tıklanabilir;
 *    uyarı kutusuyla birlikte hepsi Stand Detayı → Proje Dosyaları sekmesine
 *    `?focus=revizyonlar` ile gidip "Açık Revizyonlar" kartını vurguluyor (bkz.
 *    FirmaStandDetailPage.jsx'teki REVISIONS_ANCHOR_ID).
 */
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container, Card, CardBody, Row, Col, Input, Button, Spinner, Alert, Badge,
  Pagination, PaginationItem, PaginationLink,
  Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label,
} from "reactstrap";
import {
  Eye, RefreshCw, Package, Building2, Star, Layers,
  Maximize2, Ruler, Image as ImageIcon, Zap, Box,
  HardHat, CheckCircle2, XCircle, Upload,
  AlertTriangle, Handshake, Leaf, FileEdit, Info, ShieldCheck, ArrowRight, ArrowLeft,
  ClipboardList, Square, Check, MapPin, Map as MapIcon, FolderUp, FileText,
} from "lucide-react";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DurumSayaclari from "../../Components/Common/DurumSayaclari";
import MainContext from "../../Components/Contexts/MainContext";
import { TEKNIK_ICONS, InfoBox, TileMarker } from "../../Components/Projects/StandPills";
// #506: the Elektrik tile shows the signature level (decorator / decorator + electrician) as a dot and in its tooltip.
import { seviyeNoktasi, seviyeMetni, KOSE_SUB_IDS } from "../../Components/Projects/taahhutnameYardimci";
import { planDosyasi } from "../../Components/Projects/kusbakisiYardimci";
// #677: "Beyanı Düzenle" opens the wizard on the stored declaration, and a re-declare keeps its kW / permit.
import {
  formFromDeclaration, formFromTeknik, beyanKwKorunan, ozelIzinTekrar, cascadeSeviyeleri,
} from "../../Components/Projects/beyanOnDoldurma";
import StandInfoGrid from "../../Components/Firma/StandInfoGrid";
import StandKodKutusu from "../../Components/Firma/StandKodKutusu";
import { getFirmaProjeListesi } from "../../services/firmaProjeListService";
import StandRolRozeti, { standdaDekorator } from "../../Components/Firma/StandRolRozeti";
import {
  FILE_APPROVAL_STATUS, getProjectByStandId, getStandTypes, getStandTypePath, declareProject,
  validateDeclaration, saveDeclarationWalls, getDrawnWalls,
  getProjectDeclarationForms, blockingDeclarationForms, BEYAN_FORM_TIPI,
  requestOzelIzin, OZEL_IZIN_NOT_MAX, OZEL_IZIN_DURUM,
  getRevisableFields, createChangeRequest, isRevisionUnfinished,
  getProjeGorselleriCorners, getProjectFileUrl,
} from "../../services/projectService";
import { getEffectiveRequiredFiles } from "../../services/belgeKuralService";
import KuralIhlalListesi, {
  KuralIhlalSatiri, hasPermittableError, nonPermittableErrors,
} from "../../Components/Projects/KuralIhlalListesi";
import CikisNoktasiPinner from "../../Components/Projects/CikisNoktasiPinner";
import { cizimKonturu } from "../../Components/Projects/standKroki";
// #676: the Duvarlar step on the stand's real drawn walls (live path); the mock path keeps the fixed sketch below.
import CizilenDuvarlarFormu from "../../Components/Projects/CizilenDuvarlarFormu";
import {
  cizilenSatirlar, yaziliSatirlar, yeniYaziliSatir, gonderilecekDuvarlar, duvarlarTamam,
} from "../../Components/Projects/duvarSatirlari";
import { getEffectiveKural, describeHeightLimit } from "../../services/fuarKuralService";
// WAS (until #403): import { MOCK_DECORATOR_FIRMA_ID, TEST_DECORATOR_FIRMA_ID } from "../../services/firmaProfileService";
// WAS (until #713): mock decorator firma id (getCurrentFirmaId):
// import { MOCK_DECORATOR_FIRMA_ID } from "../../services/firmaProfileService";
// #403: the live branch takes the logged-in company's id from the portal context (GET /portal/context).
import { usePortal } from "../../Components/Contexts/PortalContext";
import {
  resolvePillLabel, CONSTRUCTION_PERMIT_GRANTED_STATUS_IDS, COMMITMENT_STATE,
  uploadStandFile, uploadKusbakisi,
} from "../../services/standOverviewService";
import {
  declareTeknikTalepler, getTeknikTalepler, TEKNIK_TALEP_KATEGORILERI, setTeknikExitPoint,
} from "../../services/standTalepService";
import { getDeclarationWarnings } from "../../services/projeBeyaniUyariService";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";

// WAS (until #713): the logged-in firma id read from localStorage with the mock fallback; the page takes portal.firmaId:
// function getCurrentFirmaId() {
//   try {
//     const user = JSON.parse(localStorage.getItem("user"));
//     return user?.firmaId ?? MOCK_DECORATOR_FIRMA_ID;
//   } catch {
//     return MOCK_DECORATOR_FIRMA_ID;
//   }
// }

// Canlı backend'e sahip test fuarları (298/299) — bkz. FirmaStandListPage.jsx/
// FirmaKartPage.jsx'teki aynı desen (dosya-yerel kopya).
// WAS (until #398): only the two seeded test fairs ran on the real backend, every other fair fell back to mock data:
// const LIVE_TEST_FUAR_IDS = [298, 299];
// const isLiveTestFuarId = (fuarId) => LIVE_TEST_FUAR_IDS.includes(Number(fuarId));
// #398: a full-simulation test creates a NEW fair, so every real fair id is live.
const isLiveTestFuarId = (fuarId) => Number(fuarId) > 0;

// 2026-08-29: taahhütnameleri stand_file 5'in alt dosyalarından TÜRETEN yerel
// yardımcı kaldırıldı — roster artık commitments[]'i doğru şekilde döndürüyor
// (kaynak belge + üretim zinciri durumu), bkz. missing-pills-guide.md §5.

// Canlı standId köprüsü — getStandOverviewList'in (bu sayfanın altında
// getFirmaProjeListesi üzerinden çağırdığı) canlı dalı proje alanlarını bilerek
// boş bırakıyor, burada projectService.getProjectByStandId sonucuyla birleştiriliyor
// (bkz. FirmaStandListPage.jsx'teki aynı isimli fonksiyon).
function mergeLiveProjectIntoRecord(record, bridged) {
  const requiredCount = bridged?.requiredCount ?? 0;
  const approvedCount = bridged?.approvedCount ?? 0;
  return {
    ...record,
    requiredCount,
    approvedCount,
    // ⚠️ 2026-08-29: constructionPermitGranted/commitments ARTIK BURADA EZİLMİYOR.
    // İnşa İzni'nin cevabı roster'daki constructionPermit.statusId — requiredCount/
    // approvedCount'tan TÜRETİLMİYOR. Eski formül, backend katalog boşluğu olan
    // standlarda (requiredCount kalıcı 0) hiçbir zaman yeşile ulaşamıyordu; bu
    // yüzden konulan stand 57557 override'ı da artık gereksiz, kaldırıldı.
    projectDeclared: bridged?.projeBeyani?.declared === true,
    fileApprovals: bridged?.fileApprovals ?? [],
    // Ham köprülenmiş proje kaydı — 2026-08-11 revizyonu: staff'ın Proje Beyanı
    // adım 1'de açtığı kayıt (kök standTypeId + söz verilen yükseklik) var ama
    // dekoratör henüz beyan etmediyse `bridged` burada zaten dolu, sadece
    // `projeBeyani.declared` false'tur — CreateProjectModal gerçek kaskadı bu
    // kaydın standTypeId'sinden başlatmak için kullanır (bkz. dosya başı
    // 2026-08-11 notu). `bridged === null` (proje kaydı hiç yok) ile "kayıt var,
    // beyan bekliyor" artık bilerek ayrı tutuluyor (aşağıda hasProject/hasShell).
    projectShell: bridged,
  };
}

const STAND_CATEGORY_META = {
  paket: { get label() { return i18n.t("portal:projeler.paket"); }, icon: Package },
  pavilyon: { get label() { return i18n.t("portal:projeler.pavilyon"); }, icon: Building2 },
  ozel: { get label() { return i18n.t("portal:projeler.ozel"); }, icon: Star },
};
// WAS (until #713): option list of the mock declaration form:
// const PROJECT_TYPE_META = {
//   moduler: { get label() { return i18n.t("portal:projeler.moduler"); }, icon: Layers },
//   ahsap: { get label() { return i18n.t("portal:projeler.ahsap"); }, icon: TreePine },
//   diger: { get label() { return i18n.t("portal:projeler.diger"); }, icon: MoreHorizontal },
// };
// WAS (until #713): option list of the mock declaration form:
// const PROJECT_STRUCTURE_META = {
//   maxima: "Maxima", octonorm: "Octonorm", mdf: "MDF", get sunta() { return i18n.t("portal:projeler.sunta"); }, get agac() { return i18n.t("portal:projeler.agac"); },
// };
// Yukarıdaki META'lar Proje Beyanı MODALININ seçenek listeleri için duruyor (mock
// kodları + ikonları). Listedeki PİLLER (#488: Components/Firma/StandInfoGrid.jsx,
// Standlarım ile ortak) ise StandPills'in etiket haritalarını kullanır — canlı roster
// adları ("Özel Stand", "Sunta - Boya") olduğu gibi basılır, bkz. resolvePillLabel.
const STAND_CATEGORY_LABELS = { get paket() { return i18n.t("portal:projeler.paket"); }, get pavilyon() { return i18n.t("portal:projeler.pavilyon"); }, get ozel() { return i18n.t("portal:projeler.ozel"); } };
// Proje Beyanı modalındaki "Proje Tipi" seçeneklerini "Proje Yapısı" seçimine göre
// filtrelemek için — projectType/projectStructure arasındaki ilişki zaten
// standOverviewService.js'teki _standListDesignOverrides yorumunda tanımlıydı, burada
// sadece UI'da kullanılabilir hale getiriliyor.
// WAS (until #713): option list of the mock declaration form:
// const PROJECT_STRUCTURE_BY_TYPE = {
//   ahsap: ["mdf", "sunta", "agac"],
//   moduler: ["maxima", "octonorm"],
// };
// Proje Beyanı modalında yeni deklarasyonlar için sunulan Proje Yapısı seçenekleri —
// 'diger' kasıtlı olarak dışarıda: sadece önceden deklare edilmiş kayıtlarda (StandInfoGrid
// üzerinden PROJECT_TYPE_META ile) gösterime devam ediyor, yeni bir seçim olarak sunulmuyor.
// WAS (until #713): option list of the mock declaration form:
// const SELECTABLE_PROJECT_TYPES = ["ahsap", "moduler"];
// floorInfo doğrudan bu iki serbest metin değerinden biri olarak saklanıyor (bkz.
// standOverviewService.js mock kayıtları) — ayrı bir kod/etiket eşlemesine gerek yok.
// WAS (until #713): option list of the mock declaration form:
// const FLOOR_INFO_OPTIONS = ["Tek Katlı", "Çift Katlı"];
// #334: the values above are what gets stored (floorInfo), so they stay Turkish; only the button
// label is translated, through these keys.
// WAS (until #713): option list of the mock declaration form:
// const FLOOR_INFO_KEYS = { "Tek Katlı": "projeler.tekKatli", "Çift Katlı": "projeler.ciftKatli" };

// 2026-08-11 revizyonu (standFileId düzeltmesi — BUG): mock veri standFileId 2=Statik
// Hesap / 5=Proje Görselleri varsayıyordu, canlı katalog (GET /projects/stand-files-classic)
// FARKLI: 2=3-D Görseller (Proje Görselleri), 3=Elektrik Planı (Teknik Talep Planı),
// 5=Taahütnameler, 7=Statik Hesap Bilgisi. Canlı standlarda bu ikisi karışınca "Proje
// Görselleri" kutucuğu aslında standFileId 5'in (gerçekte Taahütnameler) onay durumunu
// gösteriyordu — bkz. aynı düzeltmenin ayrıntılı notu FirmaStandDetailPage.jsx'te
// (bu kutucukların tıklanınca yönlendirdiği sayfa, ?kategori=<standFileId> aynı id
// şemasını paylaşmalı).
// WAS (until #713): mock catalogue ids (the live catalogue numbers them differently):
// const DOC_GROUPS_MOCK = [
//   { standFileId: 5, label: "Proje Görselleri", icon: ImageIcon },
//   { standFileId: 3, label: "Teknik Talep Planı", icon: Zap },
//   { standFileId: 2, label: "Statik Hesap", icon: Box },
// ];
const DOC_GROUPS_LIVE = [
  { standFileId: 2, get label() { return i18n.t("portal:projeler.projeGorselleri"); }, icon: ImageIcon },
  { standFileId: 3, get label() { return i18n.t("portal:projeler.teknikTalepPlani"); }, icon: Zap },
  { standFileId: 7, get label() { return i18n.t("portal:projeler.statikHesap"); }, icon: Box },
];
const COMMITMENT_GROUPS = [
  { key: "isg", get label() { return i18n.t("portal:projeler.isgTaahutname"); }, icon: HardHat },
  { key: "statik", get label() { return i18n.t("portal:projeler.statikTaahutname"); }, icon: Box },
  { key: "elektrik", get label() { return i18n.t("portal:projeler.elektrikTaahutname"); }, icon: Zap },
];

// ─── Proje Beyanı sihirbazının BELGE yarısının yazdığı stand_file id'leri ─────
// (2026-08-29, bkz. dosya sonundaki "Proje Belgeleri adımları" notu). Mock ve canlı
// katalog FARKLI numaralandırıyor — yukarıdaki DOC_GROUPS_MOCK/LIVE ile aynı ayrım,
// burada anahtar-bazlı olarak tekrarlanıyor ki adım kodu id sabiti gömmesin.
// WAS (until #713): mock catalogue ids:
// const BELGE_IDS_MOCK = { gorseller: 5, plan: 3, statik: 2 };
const BELGE_IDS_LIVE = { gorseller: 2, plan: 3, statik: 7 };

// Proje Görselleri'nin dört köşesi. Mock modda subStandFileId sabit 1-4
// (_mockProjects fixture'ları bunu bekliyor); canlı modda GERÇEK file_type id'leri
// isimle çözülür (bkz. projectService.getProjeGorselleriCorners — id'ler yerel ve
// sunucu arasında kayabildiği için asla sabit sayı gömülmez). Kuşbakışı bu listenin
// BEŞİNCİ köşesi DEĞİL: kendi adımı var ve standFileId 3'e subStandFileId'siz
// yükleniyor (bkz. FirmaStandDetailPage.jsx'teki "Kuşbakışı → Teknik Talep Planı" notu).
// WAS (until #713): fixed corner ids 1-4; the corners come from the file_type ids now (getProjeGorselleriCorners):
// const GORSEL_KOSELERI_MOCK = [
//   { subStandFileId: 1, label: "3D Köşe 1" },
//   { subStandFileId: 2, label: "3D Köşe 2" },
//   { subStandFileId: 3, label: "3D Köşe 3" },
//   { subStandFileId: 4, label: "3D Köşe 4" },
// ];

// MOCK-ONLY köprü: mock beyan yolunda gerçek bir stand_type kaskadı yok (serbest
// projectType seçimi var), ama "bu stand tipi Statik Hesap istiyor mu" sorusunu
// soran uç (getEffectiveRequiredFiles) bir standTypeId bekliyor. _mockStandTypes'ta
// 5 = Ahşap, 6 = Metal — 'ahsap' birebir karşılığına, 'moduler' en yakın metal
// karşılığına bağlanıyor. Canlı modda bu harita HİÇ kullanılmaz (gerçek kaskadın
// yaprak tipi gönderilir).
// WAS (until #713): mock stand types for the mock declaration form:
// const MOCK_STAND_TYPE_BY_PROJECT_TYPE = { ahsap: 5, moduler: 6 };

// Renkler sabit hex — bu temanın çalışma zamanı --bs-*/--vz-* CSS değişkenleri
// yok (bkz. aynı çözüm FirmaTaleplerListPage.jsx'teki TALEP_GRAY'de).
const NEUTRAL_GRAY = "#878a99";
// `info` (mavi) taahhütname üretim zinciriyle geldi — "kaynak seçildi"/"üretildi"
// beklemede de değil onaylanmış da değil, ara bir durum (bkz. COMMITMENT_STATE).
// `secondary` kasıtlı olarak yok: NEUTRAL_GRAY'e düşsün diye.
const STATUS_HEX = { warning: "#f7b84b", success: "#0ab39c", danger: "#f06548", info: "#299cdb" };

// 2026-08-29: stand 57557'nin "her zaman yeşil" demo override'ı KALDIRILDI. Gerekçesi
// (requiredCount kalıcı 0 → constructionPermitGranted hep false) ortadan kalktı: İnşa
// İzni artık belge sayımından türetilmiyor, backend'in constructionPermit.statusId'si
// doğrudan cevabı veriyor.

function VDivider() {
  return (
    <div
      className="d-none d-md-block"
      style={{ width: 1, alignSelf: "stretch", backgroundColor: "currentColor", opacity: 0.15 }}
    />
  );
}

// #488: the grey info pills (StandInfoGrid, and the InfoBox it is built from) live in
// Components/Firma/StandInfoGrid.jsx and Components/Projects/StandPills.jsx, shared with
// Standlarım. Notes that sat here moved with them: the fields all come from the
// GET /standTalep/list row, projectType is null on every live row (pill hidden, no fallback
// invented), standArea is the kroki-measured area (never "0 m²"), a null kW means "never asked".

// Proje Dosyaları/Taahhütname kareleri ortak render — gri (kayıt yok) / turuncu
// (beklemede) / yeşil (onaylandı) / kırmızı (reddedildi). onClick verildiğinde
// kare tıklanabilir olur (FirmaStandDetailPage.jsx'teki ilgili sekme/belge
// grubuna yönlendirir, bkz. ProjeStatusTiles/TaahhutnameTiles/goTo — aynı desen
// FirmaPersonelListPage.jsx'teki StatusTile'da).
// `badge` verilirse FILE_APPROVAL_STATUS yerine o kullanılır — taahhütname kareleri
// artık onay durumu değil ÜRETİM ZİNCİRİ durumu taşıyor (COMMITMENT_STATE) ve o
// zincirin altı durumu 0/1/2 onay şemasına sığmıyor.
// #506: `level` (Elektrik only) adds a dot in the corner and the level to the tooltip.
function StatusTile({ Icon, status, label, onClick, badge, level }) {
  const { t } = useTranslation("portal");
  const info = badge ?? (status != null ? FILE_APPROVAL_STATUS[status] : null);
  const background = info ? STATUS_HEX[info.color] ?? NEUTRAL_GRAY : NEUTRAL_GRAY;
  const nokta = seviyeNoktasi(level);
  const baslik = info ? `${label} — ${info.label}` : t("projeler.kayitYok", { label });
  const title = nokta ? `${baslik} · ${seviyeMetni(level)}` : baslik;
  const interactiveProps = onClick
    ? {
        role: "button",
        tabIndex: 0,
        onClick,
        onKeyDown: (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick();
          }
        },
      }
    : {};
  return (
    <div
      className={`d-flex align-items-center justify-content-center rounded-3 flex-shrink-0 ${nokta ? "position-relative" : ""}`}
      style={{ width: 40, height: 40, background, cursor: onClick ? "pointer" : undefined }}
      title={title}
      {...interactiveProps}
    >
      <Icon size={18} color="#fff" />
      {nokta && <TileMarker renk={nokta} />}
    </div>
  );
}

function ProjeStatusTiles({ record, isLive }) {
  const navigate = useNavigate();
  // WAS (until #713): const DOC_GROUPS = isLive ? DOC_GROUPS_LIVE : DOC_GROUPS_MOCK;
  const DOC_GROUPS = DOC_GROUPS_LIVE;
  const map = {};
  (record.fileApprovals || []).forEach((fa) => { map[fa.standFileId] = fa.status; });
  return (
    <div className="d-flex align-items-center gap-2">
      {DOC_GROUPS.map((g) => (
        <StatusTile
          key={g.standFileId} Icon={g.icon} status={map[g.standFileId]} label={g.label}
          onClick={() => navigate(`/Firma/Anasayfa/${record.id}?tab=files&kategori=${g.standFileId}`)}
        />
      ))}
    </div>
  );
}

function TaahhutnameTiles({ record }) {
  const navigate = useNavigate();
  const commitments = record.commitments || [];
  return (
    <div className="d-flex align-items-center gap-2">
      {COMMITMENT_GROUPS.map((g) => {
        const c = commitments.find((x) => x.key === g.key);
        return (
          <StatusTile
            key={g.key} Icon={g.icon} status={c ? c.status : null} label={g.label}
            badge={c?.state ? COMMITMENT_STATE[c.state] : undefined}
            level={c?.level}
            onClick={() => navigate(`/Firma/Anasayfa/${record.id}?tab=commitments&kategori=${g.key}`)}
          />
        );
      })}
    </div>
  );
}

// #283: sayaçlar renkli kareler (DurumSayaclari), sıfırlar çizilmez, dördü de Stand Detayı'nı YENİ SEKMEDE
// açar (2026-09-04'te dördü de aynı sekmede aynı kapıyı açıyordu). ⏱ ✓ ✗ Proje Dosyaları sekmesine, ↺ aynı sekmede
// "Açık Revizyonlar" kartına scroll'lanmış halde (bkz. FirmaStandDetailPage.jsx'teki REVISIONS_ANCHOR_ID /
// ?focus=revizyonlar). Duruma göre belge listesi SÜZÜLMEZ: detay sayfasında böyle bir süzgeç yok.
function ProjeSayacStack({ record, openRevisionCount }) {
  const { t } = useTranslation("portal");
  const approvals = record.fileApprovals || [];
  const detayUrl = `/Firma/Anasayfa/${record.id}?tab=files`;
  return (
    <DurumSayaclari
      items={[
        { key: "pending", tone: "warning", value: approvals.filter((f) => f.status === 0).length, label: t("projeler.bekleyenBelge"), href: detayUrl },
        { key: "revision", tone: "info", value: openRevisionCount ?? 0, label: t("projeler.revizyonIstenen"), href: `${detayUrl}&focus=revizyonlar` },
        { key: "approved", tone: "success", value: approvals.filter((f) => f.status === 1).length, label: t("projeler.onaylananBelge"), href: detayUrl },
        { key: "rejected", tone: "danger", value: approvals.filter((f) => f.status === 2).length, label: t("projeler.reddedilenBelge"), href: detayUrl },
      ]}
    />
  );
}

/**
 * Açık revizyon uyarısı (2026-09-04) — kartta gri bilgi kutularının SOLUNDA, göze
 * çarpacak boyutta. Sayaç yığınındaki küçük "Revizyon istenen" rakamı yeterince
 * bağırmıyordu: dekoratör kendisinden bir şey beklendiğini karta girmeden, listeye
 * bakar bakmaz anlamalı. Sayaçlarla aynı yere götürür (Proje Dosyaları →
 * "Açık Revizyonlar"). Kaynak, sayaçla AYNI: kapanmamış revizyon sayısı
 * (isRevisionUnfinished) — yani yanıtladığınız ama karara bağlanmamış olanlar da
 * uyarıyı ayakta tutar.
 */
function RevizyonUyarisi({ count, onClick }) {
  const { t } = useTranslation("portal");
  if (!count) return null;
  return (
    <div
      role="button"
      tabIndex={0}
      className="d-flex flex-column align-items-center justify-content-center rounded-3 flex-shrink-0 bg-danger text-white px-2"
      style={{
        minWidth: 62,
        alignSelf: "stretch",
        cursor: "pointer",
        boxShadow: `0 0 0 4px ${STATUS_HEX.danger}33`,
      }}
      title={t("projeler.acikRevizyonIstegiYanitlamakIcin", { count })}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <AlertTriangle size={28} strokeWidth={2.5} />
      <span className="fw-bold text-uppercase" style={{ fontSize: 10, lineHeight: 1.2, letterSpacing: ".02em" }}>
        {t("projeler.revizyon")}
      </span>
      <span className="fw-semibold" style={{ fontSize: 10, lineHeight: 1.2 }}>
        {t("projeler.istek", { count })}
      </span>
    </div>
  );
}

// #487: the stand-code box (StandThumbnail) moved to Components/Firma/StandKodKutusu.jsx, shared with
// Standlarım and the Anasayfa widgets. Its colour stays this page's: the stand's İnşa İzni status
// (bkz. dosya sonundaki izinVar hesaplaması, FirmaStandListPage.jsx'teki StandStatusTiles'daki İnşa
// İzni karesiyle aynı kaynak/mantık); proje bilgisi henüz yüklenmemiş standlarda (hasProject false)
// İnşa İzni kavramı henüz anlamlı olmadığından nötr gri (NEUTRAL_GRAY).

// Krokinin 6 duvarının (L şeklindeki poligonun 6 kenarı) orta noktaları — Proje
// Beyanı modalındaki WallDimensionsKroki'de her duvara bir tıklanabilir nokta koymak
// için. Poligon FirmaStandDetailPage.jsx'teki KrokiShape ile aynı sabit şekli
// kullanır (0 0 120 120 viewBox, points "10,10 65,10 65,65 110,65 110,110 10,110"),
// o bileşen dışa aktarılmadığı için burada küçük bir kopyası tutuluyor.
const WALL_POSITIONS = [
  { id: 1, x: 37.5, y: 10 },
  { id: 2, x: 65, y: 37.5 },
  { id: 3, x: 87.5, y: 65 },
  { id: 4, x: 110, y: 87.5 },
  { id: 5, x: 60, y: 110 },
  { id: 6, x: 10, y: 60 },
];

// Proje kaydı yok — "Proje Beyanı" modalındaki opsiyonel Kroki alanı: krokinin
// 6 duvarından birine tıklayınca o duvar seçilir (bkz. activeWall/onSelectWall,
// modal içinde altına genişlik + yükseklik input'ları açılır — bkz. dosya başı
// 2026-07-31 "duvar genişliği" notu), genişliği VEYA yüksekliği girilmiş duvarlar
// dolu (teal) gösterilir. Aynı görsel dil FirmaStandDetailPage.jsx'teki KrokiShape/
// InteractiveKrokiPin ile paylaşılır (o bileşenler dışa aktarılmadığı için burada
// küçük bir kopyası tutuluyor).
// WAS (until #713): the mock wall picker (its only user is the mock wall form above):
// function WallDimensionsKroki({ wallWidths, wallHeights, activeWall, onSelectWall, size = 140 }) {
//   const gridId = useId();
//   return (
//     <svg viewBox="0 0 120 120" width={size} height={size}>
//       <defs>
//         <pattern id={gridId} width="15" height="15" patternUnits="userSpaceOnUse">
//           <path d="M 15 0 L 0 0 0 15" fill="none" stroke="#d7dfe3" strokeWidth="1" />
//         </pattern>
//       </defs>
//       <rect width="120" height="120" fill={`url(#${gridId})`} />
//       <polygon
//         points="10,10 65,10 65,65 110,65 110,110 10,110"
//         fill="#178f8f" fillOpacity="0.18" stroke="#178f8f" strokeWidth="1.5"
//       />
//       {WALL_POSITIONS.map((w) => {
//         const hasWidth = wallWidths[w.id] != null && wallWidths[w.id] !== "";
//         const hasHeight = wallHeights[w.id] != null && wallHeights[w.id] !== "";
//         const filled = hasWidth || hasHeight;
//         const isActive = activeWall === w.id;
//         return (
//           <g
//             key={w.id} style={{ cursor: "pointer" }} onClick={() => onSelectWall(w.id)}
//             role="button" tabIndex={0}
//             onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onSelectWall(w.id); } }}
//           >
//             <circle
//               cx={w.x} cy={w.y} r={isActive ? 9 : 7}
//               fill={filled ? "#178f8f" : "#fff"}
//               stroke={isActive ? "#f06548" : "#178f8f"}
//               strokeWidth={isActive ? 2.5 : 1.5}
//             />
//             <text
//               x={w.x} y={w.y} textAnchor="middle" dominantBaseline="central" fontSize="6"
//               fill={filled ? "#fff" : "#178f8f"} style={{ pointerEvents: "none", userSelect: "none" }}
//             >
//               {w.id}
//             </text>
//           </g>
//         );
//       })}
//     </svg>
//   );
// }

// WAS (until #334): a top-level constant would freeze one language; the text is t("projeler.beyanUyarisi") now.
// const DECLARE_WARNING_TEXT =
//   "Organizatöre beyan ettiğinizden farklı bilgiler girmeniz durumunda proje işlemleriniz " +
//   "incelemeye alınacaktır ve tarafımızla iletişime geçmeniz gerekecektir.";

// kW artık sadece Talep Edeceğiniz Teknik Talepler'deki Elektrik kartından soruluyor
// (bkz. dosya başı 2026-07-31 "kW birleştirme" notu) — Ölçüler'de ayrıca sorulmuyor.
// elektrikEnabled, Elektrik kartının kendi switch'i — Su/Hava/İnternet'in aksine
// varsayılan AÇIK başlar (elektrik ihtiyacı neredeyse her stand için geçerli olduğundan);
// kapatılırsa hem input disabled olur hem submit'te elektrik talebi gönderilmez.
// Su/Hava/İnternet sadece evet/hayır (bkz. standTalepService.js'teki 2026-07-23 notu) —
// bu üçü boolean varsayılanla (kapalı) başlar.
// wallWidths/wallHeights: { [duvarId]: "değer" } — sadece kullanıcının tıklayıp
// girdiği duvarlar için anahtar taşır (bkz. WallDimensionsKroki), hepsi opsiyonel.
// Genişlik, yükseklikten ÖNCE sorulur (bkz. dosya başı 2026-07-31 "duvar genişliği"
// notu — genişlik daha önemli kabul edildiği için input sırası da buna göre).
// kullanimlar: { KOD: true|false|null } — kullanım kuralı kataloğunun (cam, boya, ...)
// cevapları (2026-09-17, backend #53; eskiden ayrı cam/boya alanlarıydı).
// null = "fuar sormuyor" — false ile AYNI ŞEY DEĞİL. false "soruldu, hayır dedim"
// demektir ve tel üzerinde de öyle gider. Sorular ancak fuar kural seti istiyorsa
// render edilir; o zaman false'a düşerler.
const EMPTY_DECLARE_FORM = {
  floorInfo: "", projectType: "", projectStructure: "",
  hMax: "", m2: "",
  elektrik: "", elektrikEnabled: true, su: false, hava: false, internet: false,
  kullanimlar: {},
  wallWidths: {}, wallHeights: {},
};

/**
 * Beyan formunun "Malzeme Beyanı" soruları — effKural.kullanimKurallari'ndan
 * (aktif kurallar, sıralı: { kod, ad, beyanSorusu, yasakMesaji, izinli, sorulsun }).
 * Liste yoksa/boşsa (eski backend) eski askGlass/askPaint alanlarından aynı şekil
 * kurulur — form iki durumda da tek yoldan çizilir.
 * ⚠️ sorulsun ile izinli iki ayrı sorudur: fuar yasağa rağmen sorabilir (sadece
 *    bilmek istiyordur) ya da sormadan yasaklamış olabilir.
 */
function resolveKullanimKurallari(eff) {
  if (!eff) return [];
  if (Array.isArray(eff.kullanimKurallari) && eff.kullanimKurallari.length > 0) {
    return eff.kullanimKurallari;
  }
  return [
    {
      kod: "CAM", ad: "cam", beyanSorusu: i18n.t("portal:projeler.standimdaCamKullanilacak"),
      yasakMesaji: i18n.t("portal:projeler.buFuardaCamliStandYasak"),
      izinli: eff.allowGlass !== false, sorulsun: eff.askGlass === true,
    },
    {
      kod: "BOYA", ad: "boya", beyanSorusu: i18n.t("portal:projeler.standimdaBoyaKullanilacak"),
      yasakMesaji: i18n.t("portal:projeler.buFuardaBoyaKullanimiYasak"),
      izinli: eff.allowPaint !== false, sorulsun: eff.askPaint === true,
    },
  ];
}

// Bir kullanım kuralının ihlallerinin geldiği `field` değerleri. CAM/BOYA eski
// alanlarında (GLASS_/PAINT_NOT_ALLOWED) kalıyor, diğerleri USAGE_NOT_ALLOWED ile
// "declaredKullanimlar.{KOD}" olarak geliyor. CAM/BOYA için harita biçimi de
// dinleniyor — backend ileride o yola geçerse ihlal kaybolmasın.
const KULLANIM_LEGACY_FIELD = { CAM: "declaredGlass", BOYA: "declaredPaint" };
function kullanimViolationFields(kod) {
  const fields = [`declaredKullanimlar.${kod}`];
  if (KULLANIM_LEGACY_FIELD[kod]) fields.unshift(KULLANIM_LEGACY_FIELD[kod]);
  return fields;
}

// /declare ve /declaration/validate gövdesinin kullanım kısmı. declaredGlass/Paint
// uyumluluk için haritanın CAM/BOYA değerinden AYRICA gönderilir (sorulmadıysa null).
function kullanimBeyanAlanlari(kullanimlar) {
  const map = kullanimlar ?? {};
  return {
    declaredKullanimlar: map,
    declaredGlass: map.CAM ?? null,
    declaredPaint: map.BOYA ?? null,
  };
}

// Küçük uyarı ipucu — staff'ın /Management/Fairs/Rules?tab=uyari'da bu
// fuar için bu alana yazdığı aktif metin varsa, alanın hemen altında gösterilir
// (bkz. dosya başı 2026-08-11 notu, projeBeyaniUyariService.getDeclarationWarnings).
function FieldWarning({ text }) {
  if (!text) return null;
  return (
    <div className="text-warning small mt-1 d-flex align-items-start gap-1">
      <AlertTriangle size={12} className="flex-shrink-0 mt-1" />
      <span>{text}</span>
    </div>
  );
}

// ─── Proje Belgeleri adımlarının yükleme kutusu (2026-08-29) ─────────────────
// Tek bir belge yuvası: küçük önizleme + "Dosya Yükle / Yeniden Yükle". Detay
// sayfasındaki (FirmaStandDetailPage.jsx) kroki-köşe "göz" düğmeleriyle AYNI
// veriye yazar, ama sihirbazın dar alanında okunaklı olsun diye düz kutu olarak
// çizilir.
// ⚠️ `slot.localUrl` yüklenen dosyanın URL.createObjectURL'idir ve MOCK MODDA TEK
//    gerçek önizleme yoludur (mock yüklemenin sunucuda karşılığı yok). Canlı modda
//    yeniden açıldığında `slot.url` (/public/files/project_files/...) devreye girer.
function BelgeYuklemeKutusu({ label, hint, slot, uploading, onUpload, height = 96 }) {
  const { t } = useTranslation("portal");
  const inputRef = useRef(null);
  const name = slot.file?.originalFileName ?? null;
  const preview = slot.localUrl ?? (slot.url && /\.(jpe?g|png|gif|webp|svg)$/i.test(name || "") ? slot.url : null);
  return (
    <div className="border rounded-3 p-2 h-100 d-flex flex-column">
      <div className="d-flex align-items-center gap-2 mb-2">
        <span className="fw-semibold small">{label}</span>
        {name
          ? <Badge color="success" className="ms-auto"><Check size={10} className="me-1" />{t("projeler.yuklendi")}</Badge>
          : <Badge color="light" className="text-dark ms-auto">{t("projeler.yok")}</Badge>}
      </div>
      <div
        className="d-flex align-items-center justify-content-center rounded-3 bg-light overflow-hidden mb-2"
        style={{ height }}
      >
        {preview
          ? <img src={preview} alt={name} style={{ maxHeight: height, maxWidth: "100%", objectFit: "contain" }} />
          : name
            ? <div className="text-center text-muted small px-2"><FileText size={20} className="mb-1" /><div className="text-truncate">{name}</div></div>
            : <ImageIcon size={22} className="text-muted" />}
      </div>
      {hint && <div className="text-muted small mb-2">{hint}</div>}
      <input
        ref={inputRef} type="file" className="d-none"
        onChange={(e) => {
          const f = e.target.files?.[0];
          if (f) onUpload(f);
          e.target.value = "";
        }}
      />
      <Button
        color="primary" outline size="sm" className="mt-auto"
        disabled={uploading} onClick={() => inputRef.current?.click()}
      >
        {uploading ? <Spinner size="sm" className="me-1" /> : <Upload size={13} className="me-1" />}
        {name ? t("projeler.yenidenYukle") : t("projeler.dosyaYukle")}
      </Button>
    </div>
  );
}

// Kabul edilmiş bir beyanı değiştirme talebi — 2026-08-25 (bkz. docs/guides/
// FE-Revisions-and-KVKK-update-guide.md). Staff beyanı kabul ettikten sonra
// POST /declare 400 döner; değişikliğin TEK yolu budur.
//
// Talep, tamponu DOLU ve durumu ANSWERED olan bir revizyon açar: kendi değerini
// taşıyan bir talebin bekleyeceği bir şey yoktur, ilk andan itibaren sıra inceleme
// ekibindedir. ⚠️ Değer, KABUL EDİLENE KADAR projeye yazılmaz — modal bunu açıkça
// söylüyor, yoksa dekoratör beyanını değiştirdiğini sanıp öyle inşa eder.
//
// Alan listesi GET /revisable-fields'ten gelir, sabit listeden DEĞİL: listede
// olmayan bir key'i backend reddeder. Fuar kurallarını çiğneyen bir değer de
// tampona park edilmez, anında {message, violations[]} ile geri döner.
function ChangeRequestModal({ record, onClose, onSubmitted, isLive }) {
  const { t } = useTranslation("portal");
  const [fields, setFields] = useState([]);
  const [fieldKey, setFieldKey] = useState("");
  const [value, setValue] = useState("");
  const [note, setNote] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [violations, setViolations] = useState([]);

  useEffect(() => {
    if (!record) return undefined;
    let ignore = false;
    getRevisableFields({ forceLive: isLive })
      .then((list) => { if (!ignore) setFields(list || []); })
      .catch(() => { if (!ignore) setFields([]); });
    return () => { ignore = true; };
  }, [record, isLive]);

  const meta = fields.find((f) => f.key === fieldKey);
  const projectId = record?.projectShell?.id;

  async function handleSubmit() {
    if (!projectId || !fieldKey || !String(value).trim()) return;
    setSubmitting(true);
    setError(null);
    setViolations([]);
    try {
      await createChangeRequest(projectId, fieldKey, value, { note: note.trim() || null, forceLive: isLive });
      onSubmitted();
    } catch (e) {
      setError(e.message);
      setViolations(e.violations || []);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Modal isOpen={!!record} toggle={onClose}>
      <ModalHeader toggle={onClose}>
        {t("projeler.degisiklikTalebi")}{record ? ` — ${record.standCode ?? record.standName}` : ""}
      </ModalHeader>
      <ModalBody>
        {error && <Alert color="danger">{error}</Alert>}
        {/* ⚠️ Düz bir <li> listesi DEĞİL: 2026-08-28'den beri üçüncü bir severity var
            (PERMITTED — onaylı bir Özel İzin'in temizlediği gerçek bir ihlal) ve düz
            liste onu diğer hatalardan ayırt edemiyordu. */}
        <KuralIhlalListesi
          violations={violations}
          title={t("projeler.talepEdilenDegerBuFuarin")}
        />
        <p className="text-muted small">
          {t("projeler.beyaninizKabulEdildigiIcinDogrudan")}{" "}<strong>{t("projeler.onaylananaKadarProjedeHicbirSey")}</strong>.
        </p>
        <FormGroup>
          <Label>{t("projeler.degistirilecekAlan")}</Label>
          <Input type="select" value={fieldKey} onChange={(e) => { setFieldKey(e.target.value); setValue(""); }}>
            <option value="">{t("projeler.secin")}</option>
            {fields.map((f) => <option key={f.key} value={f.key}>{f.label}</option>)}
          </Input>
        </FormGroup>
        {meta && (
          <FormGroup>
            <Label>{t("projeler.yeniDeger")}</Label>
            {meta.valueType === "BOOLEAN" ? (
              <Input type="select" value={value} onChange={(e) => setValue(e.target.value)}>
                <option value="">{t("projeler.secin")}</option>
                <option value="true">{t("common:evet")}</option>
                <option value="false">{t("common:hayir")}</option>
              </Input>
            ) : (
              <Input
                type="number"
                step={meta.valueType === "INTEGER" ? "1" : "0.01"}
                value={value}
                onChange={(e) => setValue(e.target.value)}
              />
            )}
            {meta.note && <div className="text-muted small mt-1">{meta.note}</div>}
          </FormGroup>
        )}
        <FormGroup>
          <Label>{t("projeler.aciklamaOpsiyonel")}</Label>
          <Input
            type="textarea" rows={3}
            placeholder={t("projeler.degisikliginGerekcesiniYazin")}
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose}>{t("common:iptal")}</Button>
        <Button color="warning" onClick={handleSubmit} disabled={submitting || !fieldKey || !String(value).trim()}>
          {submitting ? <Spinner size="sm" /> : t("projeler.talebiGonder")}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

// Proje kaydı olmayan bir stand için ilk proje beyanını toplayan modal — (1)
// Sınıflandırma: Stand Türü (salt okunur), Proje Türü/Proje Yapısı/Proje Tipi
// (seçilebilir, bkz. dosya başı 2026-07-31 notu); (2) Ölçüler: zorunlu H Max/Proje
// Alanı (m²) + opsiyonel krokideki duvar genişlik/yükseklikleri (genişlik önce
// sorulur, bkz. WallDimensionsKroki); (3) opsiyonel Teknik Talep deklarasyonu (kW
// dahil, bkz. Elektrik kartının kendi switch'i); (4) ayrıca görsel olarak ayrılmış,
// nadir kullanılan opsiyonel Sürdürülebilirlik Beyanı bağlantısı. onCreated,
// kaydedilen stand'ın id'sini alır.
//
// 2026-08-11 revizyonu (canlı köprü, isLive): Sınıflandırma bölümü artık iki farklı
// gerçekliği yansıtıyor. Mock modda hâlâ eski serbest floorInfo/projectType/
// projectStructure buton grupları (backend'de karşılığı yok, sadece mock). Canlı
// modda ise gerçek `stand_type` kaskadı — staff'ın Proje Beyanı adım 1'de açtığı
// proje kaydının KÖK tipinden (record.projectShell.standTypeId, ör. "Özel Stand")
// başlayıp GET /stand-types-classic?parentId= ile torun torun ilerler; kaskad
// çocuksuz bir seviyeye ulaştığında o seçim declaredStandTypeId olur. Böylece
// "Tek Katlı"/"Çift Katlı" gibi gerçek ara düğümler kendiliğinden çıkıyor, ayrı bir
// floorInfo eşlemesine gerek kalmıyor. Submit artık createStandProject (mock-only,
// kendi kendine kayıt+beyan yapan eski kestirme) yerine gerçek iki adımlı akışın
// SADECE 2. adımını (declareProject) çağırıyor — proje kaydının kendisi artık
// Management/Projects/Stands/:standId'de staff tarafından açılıyor (bkz.
// StandOverviewDetailPage.jsx "Proje Kaydı Oluştur").
/**
 * Proje Beyanı — ADIM ADIM (2026-08-29 yeniden sıralama).
 *
 * SORU SIRASI İŞİN GEREĞİ, keyfi değil:
 *
 *   1. m² ................ Alan, tip kurallarının (min/maks m²) yargıladığı ilk şey
 *                          ve fuar m²'yi zorunlu tutabiliyor. Önce sorulur ki 2. adımda
 *                          seçilen tip anında alan kuralına karşı sınanabilsin.
 *   2. Stand tipi ........ Kaskad; kurallar tip ağacında miras alınıyor.
 *   3. KONTROL ........... Buraya kadar YARGILANABİLEN her şey sınanır (tip yasak mı,
 *                          alan sınırlar içinde mi). Yükseklik daha SORULMADAN yanlış
 *                          bir tipin öğrenilmesi için — dekoratör dört alanı doldurup
 *                          gönderdikten sonra "bu tip bu fuarda yasak" duymasın.
 *   4. H Max ............. Yükseklik + (fuar soruyorsa) kullanım soruları (cam, boya,
 *                          ...). Tam beyan burada
 *                          gönderilir: POST /declare. ⚠️ kW ARTIK BURADA SORULMUYOR
 *                          (2026-08-29) — bkz. aşağıdaki BELGE YARISI.
 *   5. Duvarlar .......... POST /{id}/declaration/walls — AYRI bir çağrı, ayrı adım.
 *   6. Formlar ........... Fuarın kendi ek beyan formları; varsa gösterilir, yoksa
 *                          adım hiç görünmez.
 *
 * ⚠️ ADIM 4 BEYANI GÖNDERİR, adım 5 ve 6 ondan SONRAKİ ayrı yazmalardır. Bu bilinçli:
 *    duvar listesi ve fuar formları /declare'in gövdesinde değil, kendi uçlarında
 *    yaşıyor. Beyan kaydedildikten sonra pencereyi kapatmak veri kaybettirmez —
 *    duvarlar ve formlar sonradan da girilebilir.
 *
 * ═══ İKİ YARI: BEYAN ve PROJE BELGELERİ (2026-08-29) ═══════════════════════════
 *
 * Sihirbaz artık beyanla BİTMİYOR. Beyan duvar bilgisinde tamamlanır; ondan sonra
 * gelen her şey "proje belgeleri" kategorisidir ve DETAY SAYFASINDA da (Stand
 * Detayı → Proje Dosyaları / Talepler → Teknik Talepler) yapılabilir. Buraya
 * eklenmelerinin tek sebebi şu senaryo: dekoratörün eli hazırsa tek oturumda
 * bitirebilsin. Her adımı atlanabilir, pencere her an kapatılabilir.
 *
 *   7. Görseller ......... Krokinin DÖRT köşesinden proje görselleri
 *                          (standFileId 2 canlı / 5 mock, subStandFileId = köşe).
 *   8. Teknik Talepler ... Elektrik/Su/Hava/İnternet switch'leri + Elektrik'in kW
 *                          miktarı. Beyanın kW'sini yazan "Kaydet" bu adımdadır.
 *   9. Kuşbakışı ......... = TEKNİK TALEP PLANI (standFileId 3, subStandFileId YOK).
 *  10. Çıkış Noktaları ... 8. adımda açılan HER kalem için krokide bir nokta.
 *                          ⚠️ Teknik Talep Planı YÜKLENMEDEN pinleme KAPALI — nokta
 *                          gönderilen çizimle karşılaştırılarak okunuyor, çizim
 *                          yoksa işaret tahminden ibaret (bkz. CikisNoktasiPinner).
 *  11. Statik Hesap ...... SADECE bu standın belge kaskadı istiyorsa (standFileId 7
 *                          canlı / 2 mock). Kaskad GET /required-files/effective ile
 *                          sorulur; cevap veremezse projenin kendi requiredFileIds
 *                          anlık görüntüsüne düşülür, o da yoksa adım gösterilmez.
 *
 * ⚠️ 8-9-10 AYRI ADIMLARDIR (2026-09-04). Eskiden Teknik Talepler + kW + plan
 *    yüklemesi TEK bir "Kuşbakışı" adımıydı; kullanıcı bunun üç ayrı karar olduğunu
 *    söyledi ve sıra da bu: ÖNCE ne istediğini işaretle, SONRA planı yükle, EN SON
 *    o planın üstünde nereden çıkacağını göster. Sıra tersine çevrilemez — 10. adım
 *    hem 8'in kalem listesini (talepEdilenKategoriler) hem 9'un çizimini (planYuklu)
 *    okur, ikisi de yoksa pinlenecek bir şey yoktur.
 *
 * ⚠️ kW'nin yeri (2026-08-29 kararı). kW artık beyan adımlarında sorulmuyor ama
 *    `declaredKw`'yi yazan TEK uç POST /declare. Bu yüzden 8. adımın "Kaydet"i,
 *    kW değiştiyse beyanı AYNI değerlerle + kW ile YENİDEN gönderir. Bunun bir
 *    bedeli var: her başarılı /declare o projedeki canlı özel izinleri geçersiz
 *    kılıyor. Bu yüzden (a) kW değişmediyse yeniden beyan HİÇ gönderilmez ve
 *    (b) ortada bekleyen/onaylı bir özel izin varken kullanıcıya sorulur — isterse
 *    kW yalnızca Teknik Talep kaydına yazılır, beyan ellenmez.
 *
 * ⚠️ ÖZEL İZİN (2026-08-28). Beyan bir kuralı çiğniyorsa ve o ihlal
 *    `permittable` ise, dekoratöre "yine de kaydet ve izin iste" seçeneği sunulur:
 *    beyan SAKLANIR, proje KİLİTLİ kalır, bir denetmen karar verir. İzin verilemeyen
 *    ihlaller (bugün yalnız AREA_REQUIRED — boş bir alan bir ihlal değil, eksik bir
 *    cevap) bayrağa rağmen reddedilir, o yüzden seçenek onlar varken hiç açılmaz.
 * ⚠️ Bayrağı GÖNDERDİK diye izin açıldığını varsaymayın — yanıttaki
 *    `ozelIzinBekliyor` okunur (backend talep açılamazsa 200 döner ve sessizce hiçbir
 *    izin yazmaz).
 */
function CreateProjectModal({ record, onClose, onCreated, isLive, fuarId }) {
  const { t: tx } = useTranslation("portal");
  // Reset-on-open, done via a `key={record?.id}` remount from the parent (bkz.
  // aşağıdaki render) — bir Effect içinde setState çağırmak yerine, böylece
  // react-hooks/set-state-in-effect ihlaline düşülmüyor.
  // #677: the declaration already on the project (null while nothing was declared) - "Beyanı Düzenle" opens the form on it.
  const pbAtOpen = record?.projectShell?.projeBeyani?.declared === true ? record.projectShell.projeBeyani : null;
  const [form, setForm] = useState(() => ({
    ...EMPTY_DECLARE_FORM,
    ...formFromDeclaration(pbAtOpen, WALL_POSITIONS.map((w) => w.id)),
  }));
  // WAS (until #713): selected wall of the mock wall form:
  // const [activeWall, setActiveWall] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  // Sihirbaz durumu. `step` STEPS içindeki anahtar.
  const [step, setStep] = useState("m2");
  // Adım 4'te /declare başarıyla döndükten sonra dolan beyan — 5 ve 6 buna bakıyor.
  const [beyan, setBeyan] = useState(null);
  const [wallsSaved, setWallsSaved] = useState(false);
  // #676: standın ÇİZİLMİŞ duvarları (GET /drawn-walls; null = henüz okunmadı), adımın satırları, ve reddedilen son
  // duvar listesinin ihlalleri (400 JSON { message, violations[] }: walls.N.height / walls.N.aciklik) + Özel İzin seçimi.
  const [cizilen, setCizilen] = useState(null);
  const [cizilenYukleniyor, setCizilenYukleniyor] = useState(false);
  const [cizilenHata, setCizilenHata] = useState(false);
  const [duvarSatirlari, setDuvarSatirlari] = useState([]);
  const [wallViolations, setWallViolations] = useState([]);
  const [wallOzelIzinTalep, setWallOzelIzinTalep] = useState(false);
  const [wallOzelIzinNotu, setWallOzelIzinNotu] = useState("");
  // #677: the kW already on the declaration - every /declare (and the dry run) sends it back, since an absent kW clears it.
  const kwKorunan = beyanKwKorunan(beyan, pbAtOpen);

  // Özel izin talebi (2026-08-28)
  const [ozelIzinTalep, setOzelIzinTalep] = useState(false);
  const [ozelIzinNotu, setOzelIzinNotu] = useState("");

  // Canlı kaskad — levels[i] = { parentId, options: stand_type[], selectedId }.
  // levels[0]'ın parentId'si her zaman shell.standTypeId (staff'ın atadığı kök).
  const [cascadeLevels, setCascadeLevels] = useState([]);
  const [cascadeLoading, setCascadeLoading] = useState(false);

  // Bu fuar için aktif Proje Beyanı uyarıları, fieldKey → text.
  const [warnings, setWarnings] = useState({});

  // Fuarın kendi ek beyan formları + bu proje için doldurulma durumu (adım 6).
  const [beyanFormlari, setBeyanFormlari] = useState([]);
  const [formsLoading, setFormsLoading] = useState(false);

  // ─── BELGE YARISI (adım 7-10, 2026-08-29) ──────────────────────────────────
  // Bu oturumda yüklenen dosyalar: yuvaAnahtarı → { file, url }. `url` seçilen
  // dosyanın objectURL'i — mock modda yüklemenin sunucuda karşılığı olmadığı için
  // tek gerçek önizleme yolu, canlıda da anında geri bildirim veriyor (aksi halde
  // kullanıcı yüklemenin işe yarayıp yaramadığını göremezdi).
  const [uploads, setUploads] = useState({});
  const [uploadingKey, setUploadingKey] = useState(null);
  const objectUrlsRef = useRef([]);
  // Proje Görselleri köşeleri (#713): file_type id'leri, açılışta çözülür. null = çözülüyor, [] = dört köşe çözülemedi
  // (yükleme kapalı kalır; eskiden mock 1-4'e düşüp yanlış id'ye yazıyordu).
  // WAS (until #713): useState(GORSEL_KOSELERI_MOCK) - sabit subStandFileId 1-4.
  const [koseler, setKoseler] = useState(null);
  // Statik Hesap adımı gösterilsin mi. null = henüz sorulmadı.
  const [statikGerekli, setStatikGerekli] = useState(null);
  // Teknik Talep çıkış noktaları: categoryKey → {x,y} | null.
  const [points, setPoints] = useState({});
  const [teknikSaved, setTeknikSaved] = useState(false);
  // #696 (backend #695): the saved Teknik requests are drafts (not sent for approval yet) — the notice then points to the Gönder button
  const [teknikTaslak, setTeknikTaslak] = useState(false);
  const [pointsSaved, setPointsSaved] = useState(false);
  // Bekleyen/onaylı bir özel izin varken kW için beyanı YENİDEN GÖNDERMEYİ reddetme
  // seçeneği (bkz. dosya başı "kW'nin yeri" notu).
  const [kwSadeceTalep, setKwSadeceTalep] = useState(false);

  // objectURL'ler kapanışta serbest bırakılır — setState içermeyen saf temizlik.
  useEffect(() => () => { objectUrlsRef.current.forEach((u) => URL.revokeObjectURL(u)); }, []);

  // ─── Fuar Kural Sistemi (2026-08-24) ───────────────────────────────────────
  // effKural: bu (fuar, stand, beyan edilen tip) için çözülmüş sınırlar + her değerin
  // hangi seviyeden geldiği. Formun kendi limitlerini ATIFLI çizmesini sağlar
  // ("maksimum 4,00 m — Ahşap standlar için"), kullanım sorularını (cam/boya/...) fuar istemiyorsa
  // hiç göstermez ve yasaklı tipi baştan kapatır.
  const [effKural, setEffKural] = useState(null);
  // violations: /declaration/validate'in canlı cevabı (submit'te 400 gövdesiyle
  // değiştirilir). Amaç dekoratörün bir kuralı REDDEDİLEREK öğrenmemesi.
  const [violations, setViolations] = useState([]);
  const [validating, setValidating] = useState(false);
  // Adım 3'ün kendi sonucu: yalnızca m² + tip ile yargılanabilen ihlaller.
  const [preCheck, setPreCheck] = useState(null); // null = henüz çalışmadı

  const isOpen = Boolean(record);
  // Salt okunur "Stand Türü" — mock kodu ('ozel') ya da canlı ad ("Özel Stand")
  // olabilir; ikisini de resolvePillLabel çözer (bkz. StandInfoGrid'deki aynı desen).
  const standCategory = record ? resolvePillLabel(record.standCategory, STAND_CATEGORY_LABELS) : null;
  const shell = record?.projectShell ?? null;
  // Belge adımlarının yazacağı stand_file id'leri (mock/canlı katalog farkı).
  // WAS (until #713): const BELGE_IDS = isLive ? BELGE_IDS_LIVE : BELGE_IDS_MOCK;
  const BELGE_IDS = BELGE_IDS_LIVE;

  // KURAL: fetch mantığı Effect içinde tanımlanan async fonksiyona sarılır, üst
  // seviye çağrı olarak paylaşılmaz — react-hooks/set-state-in-effect ihlalini önler.
  const declaredTypeIdAtOpen = pbAtOpen?.declaredStandTypeId ?? null;
  useEffect(() => {
    if (!isOpen || !isLive || !shell?.standTypeId) return;
    let ignore = false;

    async function run() {
      setCascadeLoading(true);
      try {
        const children = await getStandTypes(shell.standTypeId, { forceLive: true });
        if (ignore) return;
        let levels = (children || []).length > 0
          ? [{ parentId: shell.standTypeId, options: children, selectedId: "" }]
          : [];
        // #677: "Beyanı Düzenle" - walk the declared type's path so the type step opens on it (a failed walk leaves the empty first level).
        if (levels.length > 0 && declaredTypeIdAtOpen != null && Number(declaredTypeIdAtOpen) !== Number(shell.standTypeId)) {
          try {
            const walked = await cascadeSeviyeleri(shell.standTypeId, declaredTypeIdAtOpen, { getStandTypePath, getStandTypes });
            if (walked && walked.length > 0) levels = walked;
          } catch { /* the type is picked again by hand */ }
          if (ignore) return;
        }
        setCascadeLevels(levels);
      } finally {
        if (!ignore) setCascadeLoading(false);
      }
    }

    run();
    return () => { ignore = true; };
  }, [isOpen, isLive, shell?.standTypeId, declaredTypeIdAtOpen]);

  // #677: the Teknik step opens on the stand's Teknik requests - saving it replaces all four, so the defaults would cancel the Su / Hava /
  // İnternet already asked for. Only on a declared stand; a failed read leaves the form as it is.
  const declaredAtOpen = pbAtOpen != null;
  useEffect(() => {
    if (!isOpen || !isLive || !declaredAtOpen || !record?.id) return undefined;
    let ignore = false;
    getTeknikTalepler(record.id, { forceLive: true })
      .then((rows) => { if (!ignore) setForm((f) => ({ ...f, ...formFromTeknik(rows) })); })
      .catch(() => {});
    return () => { ignore = true; };
  }, [isOpen, isLive, declaredAtOpen, record?.id]);

  useEffect(() => {
    if (!isOpen || !isLive || !fuarId) return;
    let ignore = false;
    getDeclarationWarnings(fuarId, { forceLive: true })
      .then((rows) => {
        if (ignore) return;
        const map = {};
        (rows || []).forEach((r) => { if (r.active && r.text) map[r.fieldKey] = r.text; });
        setWarnings(map);
      })
      .catch(() => { if (!ignore) setWarnings({}); });
    return () => { ignore = true; };
  }, [isOpen, isLive, fuarId]);

  // Fuarın ek beyan formları — açılışta bir kez. Boşsa 6. adım hiç görünmez.
  // ⚠️ Ayrı bir çağrı: her ekli serbest form bir Mongo okuması demek, listeleme
  //    sayfalarında N+1 olurdu. Proje başına bir kez sorulur.
  useEffect(() => {
    if (!isOpen || !isLive || !shell?.id) return undefined;
    let ignore = false;
    async function run() {
      setFormsLoading(true);
      try {
        const rows = await getProjectDeclarationForms(shell.id, { forceLive: true });
        if (!ignore) setBeyanFormlari(rows || []);
      } catch {
        if (!ignore) setBeyanFormlari([]);
      } finally {
        if (!ignore) setFormsLoading(false);
      }
    }
    run();
    return () => { ignore = true; };
  }, [isOpen, isLive, shell?.id]);

  // Proje Görselleri köşeleri (#713) — gerçek file_type id'leriyle (projectService.getProjeGorselleriCorners, isimle değil).
  // Dördü de çözülmezse liste boş kalır ve adım yüklemeyi reddeder; yanlış bir id'ye yüklemektense hiç yüklememek daha iyi.
  // WAS (until #713): `if (!isOpen || !isLive) return` + `list.slice(0, 4)` (Kuşbakışı beşinci isimle gelince köşe sayılabiliyordu);
  // çözülemezse GORSEL_KOSELERI_MOCK 1-4'te kalınıyordu.
  useEffect(() => {
    if (!isOpen) return undefined;
    let ignore = false;
    getProjeGorselleriCorners()
      .then((list) => {
        if (ignore) return;
        const dortKose = (list || []).filter((c) => KOSE_SUB_IDS.includes(Number(c.fileTypeId)));
        setKoseler(dortKose.length === KOSE_SUB_IDS.length ? dortKose.map((c) => c.fileTypeId) : []);
      })
      .catch(() => { if (!ignore) setKoseler([]); });
    return () => { ignore = true; };
  }, [isOpen]);

  async function handleCascadeSelect(levelIndex, typeId) {
    setCascadeLevels((prev) => {
      const next = prev.slice(0, levelIndex + 1);
      next[levelIndex] = { ...next[levelIndex], selectedId: typeId };
      return next;
    });
    setPreCheck(null); // tip değişti — 3. adımın sonucu artık geçersiz
    if (!typeId) return;
    setCascadeLoading(true);
    try {
      const children = await getStandTypes(Number(typeId), { forceLive: true });
      setCascadeLevels((prev) => {
        const next = prev.slice(0, levelIndex + 1);
        if ((children || []).length > 0) next.push({ parentId: Number(typeId), options: children, selectedId: "" });
        return next;
      });
    } finally {
      setCascadeLoading(false);
    }
  }

  // Beyan edilecek yaprak tip: kaskadın en derin seviyesinin seçili değeri. O
  // seviye çocuksuzsa (yani yaprak) zaten bir sonraki seviye hiç eklenmedi — bu
  // yüzden son levelin selectedId'si her zaman "şu ana kadarki en derin seçim".
  // Kök zaten yapraksa (nadir) cascadeLevels hiç dolmaz, kök doğrudan kullanılır.
  const declaredLeafTypeId = cascadeLevels.length > 0
    ? cascadeLevels[cascadeLevels.length - 1].selectedId
    : (shell?.standTypeId ?? "");

  // Seçilen tip değiştikçe çözülmüş kural setini çek — formun sınırları ve hangi
  // soruların sorulacağı buradan geliyor. KURAL: fetch Effect içindeki async
  // fonksiyonda tanımlanır (react-hooks/set-state-in-effect).
  // ⚠️ standTypeId OLMADAN da çağrılır ve çağrılmalıdır. Sihirbazın 1. adımı m²
  //    soruyor, ama "m² zorunlu mu" FUAR seviyesinde bir ayar (fuar_kural.m2Zorunlu) —
  //    tipe bağlı değil. Tip seçilene kadar beklersek 1. adım her fuarda "(opsiyonel)"
  //    yazar ve zorunlu m² isteyen bir fuarda dekoratörü yanıltır. Uç iki parametreyi
  //    de opsiyonel kabul ediyor: standTypeId yokken fuar geneli ayarlar anlamlı olan
  //    kısımdır, tip seçilince aynı effect daha spesifik cevapla yeniden çalışır.
  useEffect(() => {
    if (!isOpen || !isLive || !fuarId) return undefined;
    let ignore = false;

    async function run() {
      try {
        const eff = await getEffectiveKural(fuarId, {
          standId: record?.standId ?? null,
          standTypeId: declaredLeafTypeId ? Number(declaredLeafTypeId) : null,
          forceLive: true,
        });
        if (ignore) return;
        setEffKural(eff);
        // Fuar bir kullanımı soruyorsa alan null'dan false'a düşer ("soruldu, henüz
        // hayır"); sormuyorsa null KALIR ve tel üzerinde null gider — "hiç sorulmadı".
        setForm((f) => {
          const prev = f.kullanimlar ?? {};
          const next = {};
          resolveKullanimKurallari(eff).forEach((k) => {
            next[k.kod] = k.sorulsun === true ? (prev[k.kod] ?? false) : null;
          });
          return { ...f, kullanimlar: next };
        });
      } catch {
        if (!ignore) setEffKural(null);
      }
    }

    run();
    return () => { ignore = true; };
  }, [isOpen, isLive, fuarId, declaredLeafTypeId, record?.standId]);

  // ─── "Bu stand Statik Hesap istiyor mu?" (adım 10'un kapısı) ───────────────
  // Beyan gönderildikten sonra bir kez sorulur — daha önce yükseklik/tip kesin
  // değil, kaskad da yüksekliğe göre karar veriyor.
  // Cevap sırası: (1) belge kaskadı GET /required-files/effective, (2) o "hiçbir
  // seviye eşleşmedi" derse projenin kendi requiredFileIds anlık görüntüsü,
  // (3) ikisi de yoksa false — BİLMİYORSAK SORMUYORUZ. Gereksiz bir "Statik Hesap"
  // adımı, gerçekten gerekmediği halde dekoratöre belge hazırlatır.
  useEffect(() => {
    if (!isOpen || !beyan) return undefined;
    let ignore = false;

    async function run() {
      // Modül sabitlerinden okunur (türetilmiş bir nesne bağımlılık listesine
      // konsaydı her render'da yeniden kurulup effect'i sonsuz döndürürdü).
      // WAS (until #713): (isLive ? BELGE_IDS_LIVE : BELGE_IDS_MOCK).statik, and the standId / fuarId / standTypeId / forceLive below
      // each had an `isLive ? live : (null | MOCK_STAND_TYPE_BY_PROJECT_TYPE[form.projectType] ?? null)` mock side.
      const statikId = BELGE_IDS_LIVE.statik;
      const snapshot = (shell?.requiredFileIds ?? null);
      try {
        const eff = await getEffectiveRequiredFiles({
          standId: record?.standId ?? null,
          fuarId,
          standTypeId: declaredLeafTypeId ? Number(declaredLeafTypeId) : null,
          height: form.hMax === "" ? null : Number(form.hMax),
          forceLive: true,
        });
        if (ignore) return;
        const ids = (eff?.files ?? []).map((f) => Number(f.stand_file_id ?? f.standFileId));
        if (ids.length > 0) { setStatikGerekli(ids.includes(statikId)); return; }
        setStatikGerekli(snapshot ? snapshot.map(Number).includes(statikId) : false);
      } catch {
        if (!ignore) setStatikGerekli(snapshot ? snapshot.map(Number).includes(statikId) : false);
      }
    }

    run();
    return () => { ignore = true; };
  }, [isOpen, beyan, fuarId, declaredLeafTypeId, form.hMax,
    record?.standId, shell?.requiredFileIds]);

  // Yazarken canlı doğrulama — /declaration/validate HİÇBİR ŞEY yazmaz ve her zaman
  // 200 döner; boş violations[] "kabul edilirdi" demek. Debounce'lu, çünkü her tuşta
  // bir tur atmanın anlamı yok. Sadece 4. adımda çalışır: öncesinde yükseklik yok,
  // liste yarım olur ve dekoratörü boşuna korkutur.
  useEffect(() => {
    if (!isOpen || !isLive || step !== "hmax" || !shell?.id || !declaredLeafTypeId || form.hMax === "") {
      return undefined;
    }
    let ignore = false;
    const t = setTimeout(async () => {
      setValidating(true);
      try {
        // ⚠️ kW burada SORULMUYOR (bkz. dosya başı "kW'nin yeri" notu); gönderilen yalnızca beyanda zaten duran kW.
        //    #677: WAS `declaredKw: null` - /declare ile AYNI gövde olsun (boş kW silmek demek). Serbest kW
        //    uyarısı kW'nin sorulduğu 8. adımda gösterilir.
        const res = await validateDeclaration(shell.id, {
          declaredStandTypeId: Number(declaredLeafTypeId),
          declaredHeightNumber: form.hMax,
          declaredAreaM2: form.m2,
          declaredKw: kwKorunan,
          ...kullanimBeyanAlanlari(form.kullanimlar),
        }, { forceLive: true });
        if (!ignore) setViolations(res?.violations ?? []);
      } catch {
        // Doğrulama bir kolaylık — patlarsa sessizce geç, submit yine de kuralı uygular.
        if (!ignore) setViolations([]);
      } finally {
        if (!ignore) setValidating(false);
      }
    }, 500);
    return () => { ignore = true; clearTimeout(t); };
  }, [isOpen, isLive, step, shell?.id, declaredLeafTypeId,
    form.hMax, form.m2, form.kullanimlar, kwKorunan]);

  function update(field, value) {
    setForm((f) => ({ ...f, [field]: value }));
  }

  // Bir alana ait ihlalleri o inputun altında göstermek için — geri kalanı formun
  // tepesindeki toplu listede kalır (bkz. KuralIhlalListesi hideFields).
  const violationsFor = (field) => violations.filter((v) => v.field === field);
  // Fuarın bu formda SORDUĞU kullanımlar (cam, boya, ...) — bkz. resolveKullanimKurallari.
  const sorulanKullanimlar = isLive
    ? resolveKullanimKurallari(effKural).filter((k) => k.sorulsun === true)
    : [];
  // ⚠️ Bir kullanımın ihlali yalnızca sorusu ÇİZİLİYORSA tepedeki listeden gizlenir;
  //    çizilmeyen (ya da tanımadığımız) bir alanın ihlali toplu listede kalır —
  //    sessizce kaybolmasın.
  const INLINE_VIOLATION_FIELDS = [
    "declaredHeightNumber", "declaredAreaM2", "declaredKw",
    ...sorulanKullanimlar.flatMap((k) => kullanimViolationFields(k.kod)),
  ];

  function updateKullanim(kod, value) {
    setForm((f) => ({ ...f, kullanimlar: { ...(f.kullanimlar ?? {}), [kod]: value } }));
  }

  // Proje Yapısı değişince Proje Tipi seçimi sıfırlanır — eski seçim (ör. 'mdf')
  // yeni gruba (ör. moduler) ait olmayabilir (bkz. PROJECT_STRUCTURE_BY_TYPE).
  // WAS (until #713): mock declaration form handler:
  // function updateProjectType(key) {
  //   setForm((f) => ({ ...f, projectType: key, projectStructure: "" }));
  // }

  // WAS (until #713): mock wall form handler:
  // function updateWallWidth(wallId, value) {
  //   setForm((f) => ({ ...f, wallWidths: { ...f.wallWidths, [wallId]: value } }));
  // }

  // WAS (until #713): mock wall form handler:
  // function updateWallHeight(wallId, value) {
  //   setForm((f) => ({ ...f, wallHeights: { ...f.wallHeights, [wallId]: value } }));
  // }

  // ─── Belge yuvaları (adım 7-10) ────────────────────────────────────────────
  // Bir yuvanın gösterilecek hali: bu oturumda yüklenen dosya varsa O (objectURL
  // ile anında önizlenir), yoksa projede zaten duran en yeni dosya.
  function mevcutDosya(standFileId, subStandFileId = null) {
    const list = (shell?.uploadedFiles ?? []).filter((f) => !f.deleted
      && Number(f.standFileId) === Number(standFileId)
      && (subStandFileId == null
        ? (f.subStandFileId == null)
        : Number(f.subStandFileId) === Number(subStandFileId)));
    return [...list].sort((a, b) => new Date(b.uploadedAt ?? 0) - new Date(a.uploadedAt ?? 0))[0] ?? null;
  }

  function yuva(key, standFileId, subStandFileId = null) {
    const local = uploads[key];
    if (local) return { file: local.file, localUrl: local.url, url: null };
    // #696 follow-up: the "plan" slot is the Kuşbakışı drawing, filed in two places (kusbakisiYardimci.js); the newest of either.
    const existing = key === "plan" ? planDosyasi(shell?.uploadedFiles) : mevcutDosya(standFileId, subStandFileId);
    return {
      file: existing,
      localUrl: null,
      url: existing?.storedFileName ? getProjectFileUrl(existing.storedFileName) : null,
    };
  }

  async function handleBelgeUpload(key, standFileId, file, subStandFileId = null, { plan = false } = {}) {
    if (!record) return;
    // Canlı yükleme proje _id'siyle yapılır (POST /projects/{id}/files) — kayıt
    // yoksa gidilecek bir yer de yok (bkz. standOverviewService.uploadStandFile).
    if (isLive && !shell?.id) {
      setError(tx("projeler.buStandinBagliBirProje"));
      return;
    }
    // #713: a Proje Görselleri upload names its corner (subStandFileId); without one it would not be a corner, so it is refused.
    if (!plan && standFileId === BELGE_IDS.gorseller && subStandFileId == null) {
      setError(tx("projeler.koseTurleriCozulemedi"));
      return;
    }
    setUploadingKey(key);
    setError(null);
    try {
      const yukleme = { forceLive: isLive, projectId: shell?.id };
      // `plan`: the Kuşbakışı / Teknik Talep Planı drawing, filed under 3-D Görseller > Kuşbakışı and under Elektrik Planı (kusbakisiYardimci.js)
      if (plan) await uploadKusbakisi(record.id, file, yukleme);
      else await uploadStandFile(record.id, standFileId, subStandFileId, file, yukleme);
      const url = URL.createObjectURL(file);
      objectUrlsRef.current.push(url);
      setUploads((u) => ({
        ...u,
        [key]: { file: { originalFileName: file.name, uploadedAt: new Date().toISOString() }, url },
      }));
    } catch (e) {
      setError(e.message);
    } finally {
      setUploadingKey(null);
    }
  }

  // ─── Adım 3: yükseklik SORULMADAN yargılanabilenler ────────────────────────
  // Aynı /declaration/validate; sadece yüksekliği göndermiyoruz. Yükseklikle ilgili
  // ihlaller listeye hiç düşmez, çünkü değerlendirilecek bir sayı yok.
  async function runPreCheck() {
    if (!isLive || !shell?.id || !declaredLeafTypeId) {
      setPreCheck([]);
      return;
    }
    setValidating(true);
    try {
      const res = await validateDeclaration(shell.id, {
        declaredStandTypeId: Number(declaredLeafTypeId),
        declaredAreaM2: form.m2,
      }, { forceLive: true });
      // AREA_REQUIRED bu adımda anlamlı: m²'yi ilk sorduk, boşsa şimdi söyleyelim.
      // Yükseklik ihlalleri zaten gelemez (yükseklik gönderilmedi).
      setPreCheck((res?.violations ?? []).filter((v) => v.field !== "declaredHeightNumber"));
    } catch {
      setPreCheck([]);
    } finally {
      setValidating(false);
    }
  }

  // ─── Türetilmiş kapılar ────────────────────────────────────────────────────
  // Fuar "m² zorunlu" dediyse form da zorunlu tutar — backend zaten AREA_REQUIRED
  // ile reddediyor, ama dekoratörü reddedilerek öğrenmeye bırakmıyoruz.
  // WAS (until #713): isLive ? <this> : (form.m2 !== "" && Number(form.m2) > 0) - the mock side is gone, no real login reaches it.
  const m2Valid = !effKural?.m2Required || (form.m2 !== "" && Number(form.m2) > 0);

  // Yasaklı bir tip seçiliyse gönderim baştan kapalı.
  // WAS (until #713): isLive ? <this> : (form.floorInfo !== "" && form.projectType !== "" && form.projectStructure !== "")
  const typeValid = Boolean(declaredLeafTypeId) && !effKural?.forbidden;

  const requiredValid = typeValid && m2Valid && form.hMax !== "" && Number(form.hMax) > 0;

  // Canlı doğrulamada ERROR varsa normal gönderim kapalı — WARNING kapatmaz
  // (serbest kW aşımı beyanı engellemez, para demek).
  const hasBlockingViolation = violations.some((v) => (v.severity ?? "ERROR") === "ERROR");
  // ⚠️ İzin verilemeyen bir ihlal varsa bayrak İŞE YARAMAZ — backend bayrağa rağmen
  //    reddeder ve hiçbir izin satırı yazmaz. O yüzden seçeneği hiç açmıyoruz.
  const blockers = nonPermittableErrors(violations);
  const canRequestPermit = isLive && hasPermittableError(violations) && blockers.length === 0;
  // Özel izin talebiyle gönderim, ERROR olsa bile serbest.
  const canSubmitDeclare = requiredValid && !submitting
    && (!hasBlockingViolation || (canRequestPermit && ozelIzinTalep));

  // ─── Adım listesi ──────────────────────────────────────────────────────────
  // Fuarın ek formu yoksa 6. adım hiç yok. Mock modda 3. adım (kontrol) yok:
  // yargılayacak bir kural seti mevcut değil.
  //
  // İKİ AYRI LİSTE (2026-08-29): BEYAN adımları ve BELGE adımları. Adım göstergesi
  // yalnızca İÇİNDE BULUNULAN yarıyı çizer — hepsini yan yana basmak 10 rozet
  // demekti ve bir modalda okunmuyordu. Yarılar arasındaki geçiş TEK YÖNLÜ ve
  // AÇIK BİR KARAR: beyanın son adımındaki "Proje Belgelerine Geç" düğmesi.
  const hasExtraForms = isLive && beyanFormlari.length > 0;
  const BEYAN_STEPS = [
    { key: "m2", label: tx("projeler.alan"), icon: Maximize2 },
    { key: "tip", label: tx("projeler.standTipi"), icon: Layers },
    ...(isLive ? [{ key: "kontrol", label: tx("projeler.kontrol"), icon: ShieldCheck }] : []),
    { key: "hmax", label: tx("projeler.yukseklik"), icon: Ruler },
    { key: "duvarlar", label: tx("projeler.duvarlar"), icon: Square },
    ...(hasExtraForms ? [{ key: "formlar", label: tx("projeler.formlar"), icon: ClipboardList }] : []),
  ];
  // Statik Hesap adımı yalnızca kaskad istiyorsa (bkz. statikGerekli effect'i).
  const BELGE_STEPS = [
    { key: "gorseller", label: tx("projeler.gorseller"), icon: ImageIcon },
    { key: "talepler", label: tx("projeler.teknikTalepler"), icon: Zap },
    { key: "plan", label: tx("projeler.kusbakisi"), icon: MapIcon },
    { key: "cikis", label: tx("projeler.cikisNoktalari"), icon: MapPin },
    ...(statikGerekli ? [{ key: "statik", label: tx("projeler.statikHesap"), icon: Box }] : []),
  ];
  const BELGE_STEP_KEYS = BELGE_STEPS.map((s) => s.key);
  const inBelgePhase = BELGE_STEP_KEYS.includes(step);
  const STEPS = inBelgePhase ? BELGE_STEPS : BEYAN_STEPS;
  const stepIndex = Math.max(0, STEPS.findIndex((x) => x.key === step));
  const isLastStep = stepIndex === STEPS.length - 1;
  const isLastBeyanStep = !inBelgePhase && stepIndex === BEYAN_STEPS.length - 1;

  // ⚠️ Beyan GÖNDERİLDİKTEN sonra pencereyi kapatmak "vazgeçmek" değil, BİTİRMEKTİR
  //    — listenin yenilenmesi gerekir, aksi halde kart hâlâ "Proje Beyanı Yap"
  //    düğmesini gösterir ve dekoratör beyanının kaydedilmediğini sanır (dosya başı
  //    "İKİ YARI" notu: belge adımlarını yarıda bırakmak tamamen geçerli bir sonuç).
  function handleClose() {
    if (beyan) onCreated();
    else onClose();
  }

  // Beyan → Proje Belgeleri geçişi. Beyan bu noktada KAYDEDİLMİŞTİR; buradan
  // sonrası tamamen opsiyonel ve Stand Detayı sayfasından da yapılabilir.
  // ⚠️ Tek yönlü: belge yarısından beyan adımlarına dönülmüyor (dönmek yeni bir
  //    /declare demek olurdu). Beyanı değiştirmek isteyen kartdaki "Beyanı Düzenle"
  //    (kabul edilmemişse) ya da "Değişiklik Talebi" (kabul edilmişse) yolunu kullanır.
  function enterBelgeYarisi() {
    setStep(BELGE_STEPS[0].key);
  }

  // Adım 3'e girerken kontrolü otomatik çalıştır — kullanıcı bir düğmeye daha
  // basmak zorunda kalmasın; sonucu zaten görmeye geldi.
  function enterKontrol() {
    setStep("kontrol");
    setPreCheck(null);
    runPreCheck();
  }

  // Adım 3'te sadece BU ADIMDA yargılanabilen ERROR varsa ilerlemeyi kapat.
  const preCheckErrors = (preCheck ?? []).filter((v) => (v.severity ?? "ERROR") === "ERROR");
  const preCheckBlocked = preCheck != null && preCheckErrors.length > 0;

  // ─── Adım 4: beyanı gönder ─────────────────────────────────────────────────
  async function handleDeclare() {
    if (!requiredValid || !record) return;
    setSubmitting(true);
    setError(null);
    try {
      // ⚠️ kW BU ADIMDA SORULMAZ (2026-08-29). Beyanın kW'si 8. adımın "Kaydet"inde,
      //    aynı gövdeyle ikinci bir /declare olarak yazılıyor — bkz. handleSaveTeknik ve
      //    dosya başındaki "kW'nin yeri" notu. null "elektrik beyan edilmedi" demek
      //    (0 sahte bir "0 kW" rozeti bastırırdı) ama #677'den beri yalnızca beyanda
      //    HİÇ kW yokken: backend eksik kW'yi "sil" diye okur, yeniden beyan Teknik
      //    adımın yazdığı kW'yi sessizce siliyordu.
      let pb = null;
      if (isLive) {
        if (!shell) throw new Error(tx("projeler.buStandIcinProjeKaydi"));
        // Beyan artık tip+yükseklikten ibaret değil: m² ve kullanım cevapları (cam,
        // boya, ...) da beyanın parçası ve hepsi fuar kural setine karşı yargılanıyor.
        pb = await declareProject(shell.id, {
          declaredStandTypeId: Number(declaredLeafTypeId),
          declaredHeightNumber: form.hMax,
          declaredAreaM2: form.m2,
          declaredKw: kwKorunan,
          ...kullanimBeyanAlanlari(form.kullanimlar),
          // Bayrak yalnızca gerçekten istendiğinde gider; yokluğu false demek ve
          // mevcut davranışı hiç değiştirmiyor.
          ozelIzinTalep: canRequestPermit && ozelIzinTalep,
          ozelIzinNotu: canRequestPermit && ozelIzinTalep ? ozelIzinNotu : null,
        }, { forceLive: true });
      }
      // WAS (until #713): } else { await createStandProject(record.id, { floorInfo, projectType, projectStructure, hMax, m2, kw: null, wallWidths, wallHeights }); }
      // Beyan kaydedildi. Yanıttaki violations artık GERÇEK durum (PERMITTED dahil).
      setBeyan(pb ?? { declared: true });
      setViolations(pb?.violations ?? []);
      setStep("duvarlar");
    } catch (e) {
      // /declare'in İKİ farklı 400 gövdesi var: yapısal problemler DÜZ METİN, kural
      // ihlalleri JSON { message, violations[] }. parseError ikisini de karşılayıp
      // ihlalleri err.violations'a takıyor (bkz. projectService.js).
      setViolations(e.violations ?? []);
      setError(e.violations?.length ? null : e.message);
    } finally {
      setSubmitting(false);
    }
  }

  // ─── Adım 5: duvarlar ──────────────────────────────────────────────────────
  // ⚠️ wallCount gönderim anında walls.length'ten hesaplanır — formda ayrı bir sayaç
  //    tutmak, uyuşmazlık 400'ünü kullanıcıya backend hatası gibi gösterirdi.
  // WAS (until #713): wallRows / wallsComplete, the six fixed wall points of the mock WallDimensionsKroki form:
  // const wallRows = WALL_POSITIONS
  //   .map((w) => ({ id: w.id, width: form.wallWidths[w.id], height: form.wallHeights[w.id] }))
  //   .filter((w) => (w.width !== "" && w.width != null) || (w.height !== "" && w.height != null));
  // const wallsComplete = wallRows.length > 0
  //   && wallRows.every((w) => Number(w.width) > 0 && Number(w.height) > 0);

  // ─── #676: canlı yolda adım standın ÇİZİLMİŞ duvarlarını gösterir ───────────────────────────
  // ESKİSİ: her stand için aynı sabit L şekilli 6 duvar (WallDimensionsKroki), çizimle ilgisiz; yalnızca doldurulan
  // duvarlar gidiyordu. ŞİMDİ: çizimdeki her kenar için bir satır, çizilen uzunluk başlangıç genişliği, koridora
  // bakan kenarlarda açıklık; edgeIndex + shapeId + aciklik duvarla birlikte gider, böylece fuarın #675 kuralı
  // gerçek bir beyanı yargılayabilir. (#713: bağlantısız kayıt için eski kroki yolu kaldırıldı.)
  const canliDuvarlar = isLive && Boolean(shell?.id);
  // WAS (until #713): canliDuvarlar ? <this> : wallsComplete
  const duvarKaydedilebilir = canliDuvarlar && (cizilen != null || cizilenHata) && duvarlarTamam(duvarSatirlari, cizilen);
  // Reddedilen son listede izin verilebilir ihlal varsa beyan adımındaki gibi Özel İzin yolu açılır; izin
  // verilemeyen (H Max aşımı, eksik açıklık) bayrakla kurtarılamaz.
  const wallBlockers = nonPermittableErrors(wallViolations);
  const canRequestWallPermit = canliDuvarlar && hasPermittableError(wallViolations) && wallBlockers.length === 0;
  const kayitliDuvarlar = beyan?.walls ?? shell?.projeBeyani?.walls ?? null;

  // #676: Çıkış Noktaları adımı da aynı çizimi kullanır (pin standın gerçek ana hattı üzerinde); o adıma doğrudan gelinirse okunur.
  // WAS: yalnızca step === "duvarlar" iken okunurdu.
  useEffect(() => {
    if (!isOpen || !isLive || (step !== "duvarlar" && step !== "cikis") || !shell?.id || cizilen != null || cizilenHata) return undefined;
    let ignore = false;

    async function run() {
      setCizilenYukleniyor(true);
      try {
        const res = await getDrawnWalls(shell.id, { forceLive: true });
        if (ignore) return;
        setCizilen(res);
        setDuvarSatirlari(res?.drawn ? cizilenSatirlar(res, kayitliDuvarlar) : yaziliSatirlar(kayitliDuvarlar));
      } catch {
        // Okunamayan çizim beyanı durdurmaz: duvarlar elle yazılır (çizim kuralları onları yargılayamaz).
        if (ignore) return;
        setCizilenHata(true);
        setDuvarSatirlari(yaziliSatirlar(kayitliDuvarlar));
      } finally {
        if (!ignore) setCizilenYukleniyor(false);
      }
    }

    run();
    return () => { ignore = true; };
  }, [isOpen, isLive, step, shell?.id, cizilen, cizilenHata, kayitliDuvarlar]);

  // #676: standın çizilmiş ana hattı (çizimin köşeleri itilmişse); yoksa Çıkış Noktaları adımı eski L şekliyle kalır.
  const cizimKontur = useMemo(() => cizimKonturu(cizilen), [cizilen]);

  function handleDuvarSatiriDegis(key, patch) {
    setDuvarSatirlari((prev) => prev.map((s) => (s.key === key ? { ...s, ...patch } : s)));
    setWallsSaved(false);
    // Bir kenarın duvarı eklenip kaldırılınca alttaki satırların numarası kayar: son reddin alanları artık tutmaz.
    if (Object.prototype.hasOwnProperty.call(patch, "dahil")) setWallViolations([]);
  }

  function handleDuvarSatiriEkle() {
    setDuvarSatirlari((prev) => [...prev, yeniYaziliSatir()]);
    setWallsSaved(false);
    setWallViolations([]);
  }

  function handleDuvarSatiriSil(key) {
    setDuvarSatirlari((prev) => (prev.length > 1 ? prev.filter((s) => s.key !== key) : prev));
    setWallsSaved(false);
    setWallViolations([]);
  }

  async function handleSaveWalls() {
    // WAS (until #676): if (!wallsComplete) return;
    if (!duvarKaydedilebilir) return;
    setSubmitting(true);
    setError(null);
    try {
      if (isLive && shell?.id) {
        // WAS (until #676): const pb = await saveDeclarationWalls(shell.id, wallRows, { forceLive: true });
        const pb = await saveDeclarationWalls(shell.id, gonderilecekDuvarlar(duvarSatirlari), {
          forceLive: true,
          ozelIzinTalep: canRequestWallPermit && wallOzelIzinTalep,
          ozelIzinNotu: canRequestWallPermit && wallOzelIzinTalep ? wallOzelIzinNotu : null,
        });
        setBeyan(pb);
        setViolations(pb?.violations ?? violations);
        setWallViolations([]);
      }
      // WAS (until #713): } else if (record) { await createStandProject(record.id, { ..., wallWidths: form.wallWidths, wallHeights: form.wallHeights }); }
      // (the mock path kept the walls on the stand's own fields; no real login reaches it.)
      setWallsSaved(true);
      // ⚠️ KAYDETMEK OTOMATİK İLERLETMEZ (2026-08-29 değişikliği). Duvar bilgisi
      //    beyanın son parçası; buradan sonrası ayrı bir yarı ("proje belgeleri")
      //    ve oraya geçmek dekoratörün AÇIK kararı olmalı — beyanını bitirip
      //    kapatmak da tamamen geçerli bir sonuç. Fuarın ek formu varsa o hâlâ
      //    beyan yarısına ait, ona ilerlenir.
      if (hasExtraForms) setStep("formlar");
    } catch (e) {
      // #678 / #675: kural ihlali olan bir duvar listesi reddedilir — 400 JSON { message, violations[] }, alanlar
      // walls.N.height / walls.N.aciklik; parseError ihlalleri e.violations'a taşır. Beyan adımı gibi gösterilir.
      // WAS (until #676): setError(e.message);
      setWallViolations(e.violations ?? []);
      setError(e.violations?.length ? null : e.message);
    } finally {
      setSubmitting(false);
    }
  }

  const stepValid = {
    m2: m2Valid,
    tip: typeValid,
    kontrol: preCheck != null && !preCheckBlocked,
    hmax: canSubmitDeclare,
    duvarlar: true,
    formlar: true,
    gorseller: true,
    talepler: true,
    plan: true,
    cikis: true,
    statik: true,
  }[step];

  const permitPending = beyan?.ozelIzinBekliyor === true;
  const declareSent = Boolean(beyan);
  // Modal AÇILDIĞINDA projede zaten duran canlı izin (bekleyen ya da onaylı).
  // `beyan` bu oturumda gönderdiğimiz cevap; bu ise kartın taşıdığı önceki durum.
  const pbExisting = record?.projectShell?.projeBeyani ?? null;
  const existingPermit = pbExisting?.ozelIzin ?? null;

  // ─── Adım 8-9: Teknik Talepler + kW, ve Kuşbakışı / Teknik Talep Planı ────
  const planSlot = yuva("plan", BELGE_IDS.plan);
  const planYuklu = Boolean(planSlot.file);
  // Talep edilen (switch'i açık) kategoriler — 10. adımda birer pin alırlar.
  const talepEdilenKategoriler = TEKNIK_TALEP_KATEGORILERI.filter((c) => (
    c.type === "quantity" ? form[`${c.key}Enabled`] : form[c.key]
  ));
  const elektrikKwEksik = form.elektrikEnabled && String(form.elektrik ?? "") === "";

  // Beyanda duran kW ile formdaki kW aynı mı — aynıysa beyanı YENİDEN GÖNDERMİYORUZ
  // (her başarılı /declare canlı özel izinleri geçersiz kılar, bedava tekrar yok).
  const formKw = form.elektrikEnabled && form.elektrik !== "" ? Number(form.elektrik) : null;
  const beyanKw = beyan?.declaredKw ?? null;
  const kwDegisti = (formKw ?? null) !== (beyanKw == null ? null : Number(beyanKw));
  // Bekleyen ya da onaylı bir izin varken yeniden beyan o izni öldürür — kullanıcıya
  // sorulur (bkz. dosya başı "kW'nin yeri" notu).
  const izinRiskte = beyan?.ozelIzinBekliyor === true || beyan?.ozelIzinli === true;
  const kwYenidenBeyan = isLive && Boolean(shell?.id) && kwDegisti && !(izinRiskte && kwSadeceTalep);

  async function handleSaveTeknik() {
    if (!record || elektrikKwEksik) return;
    setSubmitting(true);
    setError(null);
    try {
      const elektrikValue = form.elektrikEnabled ? form.elektrik : "";
      // ⚠️ PUT /teknik TAM DEĞİŞTİRMEDİR — dördü de her zaman birlikte gönderilir,
      //    eksik gönderim kalanları siler (bkz. standTalepService.js).
      // #696: DECIDED (not sending): the declaration does NOT call Gönder after saving. Gönder sends every draft of the stand, the other company's
      // included, and needs the stand's Kuşbakışı, which this wizard may not have uploaded yet at this step; so the drafts wait and the notice below
      // sends the company to the Talepler page, where the one Gönder button says what is still missing.
      const rows = await declareTeknikTalepler(record.id, {
        elektrik: elektrikValue, su: form.su, hava: form.hava, internet: form.internet,
      }, { forceLive: isLive });
      setTeknikTaslak(Array.isArray(rows) && rows.some((r) => r.taslak));

      if (kwYenidenBeyan) {
        // Aynı beyan, sadece kW eklenmiş hali. Ret gelirse (staff bu arada kabul
        // etmişse 400) teknik talep zaten yazıldı — kullanıcıyı boş yere durdurmayıp
        // yalnızca beyanın güncellenemediğini söylüyoruz.
        try {
          const pb = await declareProject(shell.id, {
            declaredStandTypeId: Number(declaredLeafTypeId),
            declaredHeightNumber: form.hMax,
            declaredAreaM2: form.m2,
            declaredKw: formKw,
            ...kullanimBeyanAlanlari(form.kullanimlar),
            // #677: a declaration stored with a permit still breaks its rule, so without the flag this /declare was refused
            // ("kW could not be updated"). It goes again, with the note given the first time.
            ...ozelIzinTekrar(beyan, ozelIzinNotu),
          }, { forceLive: true });
          setBeyan(pb);
          setViolations(pb?.violations ?? []);
        } catch (e) {
          setViolations(e.violations ?? []);
          setError(e.violations?.length
            ? null
            : tx("projeler.teknikTaleplerinizKaydedildiAncakKW", { message: e.message }));
        }
      }
      // WAS (until #713): } else if (!isLive && record) { await createStandProject(record.id, { ..., kw: elektrikValue !== "" ? elektrikValue : null, ... }); }
      // (the mock path kept the kW on the stand's own field; no real login reaches it.)
      setTeknikSaved(true);
    } catch (e) {
      setError(e.message);
    } finally {
      setSubmitting(false);
    }
  }

  // ─── Adım 10: çıkış noktaları ─────────────────────────────────────────────
  // ⚠️ setTeknikExitPoint KASITLI OLARAK forceLive almıyor — backend'de
  //    `cikis-noktasi` ucu yok, nokta her zaman standTalepService'in mock deposuna
  //    yazılır (bkz. o dosyanın dosya başı notu). SPA oturumu boyunca Talepler
  //    sayfasıyla aynı kaydı paylaşır, tam sayfa yenilemede sıfırlanır.
  async function handleSavePoints() {
    if (!record) return;
    setSubmitting(true);
    setError(null);
    try {
      await Promise.all(
        talepEdilenKategoriler
          .filter((c) => points[c.key])
          .map((c) => setTeknikExitPoint(record.id, c.key, points[c.key]))
      );
      setPointsSaved(true);
    } catch (e) {
      setError(e.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={submitting ? undefined : handleClose} centered size="lg">
      <ModalHeader toggle={submitting ? undefined : handleClose}>
        {inBelgePhase ? tx("projeler.projeBelgeleri") : tx("projeler.projeBeyani")}
        {record ? ` — ${record.standCode ?? record.standName}` : ""}
      </ModalHeader>
      <ModalBody>
        {/* ─── Adım göstergesi ─── */}
        {/* Yalnızca İÇİNDE BULUNULAN yarının adımları çizilir (bkz. BEYAN_STEPS/
            BELGE_STEPS notu) — baştaki koyu rozet hangi yarıda olduğumuzu söyler. */}
        <div className="d-flex align-items-center flex-wrap gap-1 mb-3">
          <Badge color="dark" className="me-1">
            {inBelgePhase
              ? <><FolderUp size={11} className="me-1" />{tx("projeler.projeBelgeleri")}</>
              : <><ClipboardList size={11} className="me-1" />{tx("projeler.beyan")}</>}
          </Badge>
          {STEPS.map((st, i) => {
            const Icon = st.icon;
            const done = i < stepIndex;
            const active = i === stepIndex;
            return (
              <React.Fragment key={st.key}>
                <Badge
                  color={active ? "primary" : done ? "success" : "light"}
                  className={done || active ? "" : "text-dark"}
                >
                  {done ? <Check size={11} className="me-1" /> : <Icon size={11} className="me-1" />}
                  {i + 1}. {st.label}
                </Badge>
                {i < STEPS.length - 1 && <ArrowRight size={12} className="text-muted" />}
              </React.Fragment>
            );
          })}
        </div>

        {error && <Alert color="danger">{error}</Alert>}

        {/* ⚠️ HER BAŞARILI /declare, O PROJEDEKİ CANLI ÖZEL İZİNLERİ GEÇERSİZ KILAR —
            kural çiğnemeyen temiz bir yeniden beyan bile. Sebep basit: 4,50 m için
            verilmiş bir izin 12,00 m'lik yeni bir beyanı sessizce kapsamamalı. Ama
            dekoratör bunu bilmiyor ve "Beyanı Düzenle"ye basıp bekleyen (ya da
            onaylanmış) iznini farkında olmadan öldürebilir. Beyan gönderilmeden önce,
            sihirbazın her adımında söylüyoruz. */}
        {!declareSent && existingPermit && (
          <Alert color="warning" className="d-flex align-items-start gap-2">
            <ShieldCheck size={17} className="flex-shrink-0 mt-1" />
            <span>
              {/* `durumName` ("Onay Bekliyor") bir sıfat değil, cümlenin içinde
                  bozuk okunuyor — sıfat halini kendimiz kuruyoruz. */}
              {tx("projeler.buProjede")}
              <span className="fw-semibold">
                {pbExisting?.ozelIzinBekliyor ? tx("projeler.onayBekleyen") : tx("projeler.onaylanmis")}
              </span>{" "}
              {tx("projeler.birYardimMerkeziTalebinizVar", { id: existingPermit.id })}
              <span className="fw-semibold">{tx("projeler.buTalepGecersizOlur")}</span>{" "}{tx("projeler.veGerekiyorsaYenidenIletmenizGerekir")}
            </span>
          </Alert>
        )}

        {/* ═══ ADIM 1 — ALAN ═══ */}
        {step === "m2" && (
          <>
            <div className="fw-semibold mb-2">{tx("projeler.standAlani")}</div>
            <div className="text-muted small mb-3">
              {tx("projeler.standinizinKacMOldugunuIlk")}
            </div>
            <Row className="g-3 mb-3">
              <Col md={6}>
                <FormGroup className="mb-0">
                  <Label size="sm">
                    {tx("projeler.projeAlaniM")}
                    {isLive && !effKural?.m2Required && <span className="text-muted fw-normal">{" "}{tx("projeler.opsiyonel")}</span>}
                    {isLive && effKural?.m2Required && <span className="text-danger"> *</span>}
                  </Label>
                  <Input
                    type="number" min="0" step="0.1" bsSize="sm" autoFocus
                    value={form.m2} onChange={(e) => { update("m2", e.target.value); setPreCheck(null); }}
                  />
                  {isLive && (effKural?.minM2 != null || effKural?.maxM2 != null) && (
                    <div className="text-muted small mt-1">
                      <Info size={12} className="me-1" />
                      {effKural.minM2 != null && <>{tx("projeler.enAz")}{" "}<span className="fw-semibold">{effKural.minM2} m²</span></>}
                      {effKural.minM2 != null && effKural.maxM2 != null && " · "}
                      {effKural.maxM2 != null && <>{tx("projeler.enCok")}{" "}<span className="fw-semibold">{effKural.maxM2} m²</span></>}
                      {effKural.minM2FromStandTypeName && <>{" "}{tx("projeler.standlarIcin", { minM2FromStandTypeName: effKural.minM2FromStandTypeName })}</>}
                    </div>
                  )}
                  <FieldWarning text={warnings.m2} />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="mb-0">
                  <Label size="sm">{tx("projeler.stand")}</Label>
                  <div>
                    {standCategory
                      ? <InfoBox icon={Package} label={standCategory} />
                      : <span className="text-muted small">—</span>}
                  </div>
                </FormGroup>
              </Col>
            </Row>
            {/* m² sınırları tipe bağlı; tip henüz seçilmediyse gösterilecek bir sınır
                da yok. Bunu söylemezsek "neden sınır yazmıyor?" sorusu gelir. */}
            {isLive && !declaredLeafTypeId && (
              <div className="text-muted small">
                <Info size={12} className="me-1" />
                {tx("projeler.alanSinirlariStandTipineGore")}
              </div>
            )}
          </>
        )}

        {/* ═══ ADIM 2 — STAND TİPİ ═══ */}
        {step === "tip" && (
          <>
            <div className="fw-semibold mb-2">{tx("projeler.siniflandirma")}</div>
            {isLive && (
              <Row className="g-3 mb-3 align-items-end">
                <Col md={3}>
                  <FormGroup className="mb-0">
                    <Label size="sm">{tx("projeler.standTuruKok")}</Label>
                    <div>
                      <InfoBox icon={Building2} label={shell?.standTypeName ?? "—"} />
                    </div>
                  </FormGroup>
                </Col>
                {cascadeLevels.map((lvl, i) => (
                  <Col md={3} key={lvl.parentId}>
                    <FormGroup className="mb-0">
                      <Label size="sm">{i === 0 ? tx("projeler.altTip") : tx("projeler.altTip2", { v: i + 1 })}</Label>
                      <Input
                        type="select" bsSize="sm"
                        value={lvl.selectedId}
                        onChange={(e) => handleCascadeSelect(i, e.target.value)}
                      >
                        <option value="">{tx("projeler.secin")}</option>
                        {lvl.options.map((t) => (
                          <option key={t.stand_type_id} value={t.stand_type_id}>{t.stand_type_name}</option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                ))}
                {cascadeLoading && (
                  <Col md="auto" className="d-flex align-items-center">
                    <Spinner size="sm" />
                  </Col>
                )}
                {!cascadeLoading && shell && cascadeLevels.length === 0 && (
                  <Col md={3} className="text-muted small">{tx("projeler.buKokTipinAltTipi")}</Col>
                )}
                {/* Bir alt tip seçilince kaskad BİR SEVİYE DAHA açılabiliyor ve beyan en
                    derin seviyeyle yapılıyor — o seviye boşken "Devam" kapalı kalır.
                    Sebebini yazmazsak dekoratör kapalı bir düğmeye bakıp kalıyor. */}
                {!cascadeLoading && cascadeLevels.length > 0 && !declaredLeafTypeId && (
                  <Col xs={12}>
                    <div className="text-muted small">
                      <Info size={12} className="me-1" />
                      {tx("projeler.devamEdebilmekIcin")}{" "}<span className="fw-semibold">{tx("projeler.enAlttakiSeviyeyiDe")}</span>{" "}{tx("projeler.secinBeyanSectiginizEnSpesifik")}
                    </div>
                  </Col>
                )}
                {/* Yasak bir tip seçildiyse hemen burada söyle — dört alanı doldurup
                    gönderdikten sonra öğrenmesin. */}
                {effKural?.forbidden && (
                  <Col xs={12}>
                    <Alert color="danger" className="mb-0 py-2 small d-flex align-items-start gap-2">
                      <XCircle size={15} className="flex-shrink-0 mt-1" />
                      <span>
                        <span className="fw-semibold">{effKural.standTypeName ?? tx("projeler.buTip")}</span>{" "}
                        {tx("projeler.buFuardaBeyanEdilemiyor")}
                        {effKural.forbiddenFromStandTypeName && effKural.forbiddenFromStandTypeName !== effKural.standTypeName
                          ? tx("projeler.kuralTipindenMirasAliniyor", { forbiddenFromStandTypeName: effKural.forbiddenFromStandTypeName })
                          : ""}{tx("projeler.lutfenBaskaBirAltTip")}
                      </span>
                    </Alert>
                  </Col>
                )}
              </Row>
            // WAS (until #713): the mock Proje Beyani form (kat bilgisi / proje yapisi / proje tipi); the live type cascade above is the only path:
            // ) : (
            //   <Row className="g-3 mb-3">
            //     <Col md={4}>
            //       <FormGroup className="mb-0">
            //         <Label size="sm" className="d-block">{tx("projeler.projeTuru")}</Label>
            //         <ButtonGroup>
            //           {FLOOR_INFO_OPTIONS.map((opt) => (
            //             <Button
            //               key={opt} type="button" size="sm" color="info"
            //               outline={form.floorInfo !== opt}
            //               onClick={() => update("floorInfo", opt)}
            //             >
            //               {/* WAS (until #334): {opt} */}
            //               {FLOOR_INFO_KEYS[opt] ? tx(FLOOR_INFO_KEYS[opt]) : opt}
            //             </Button>
            //           ))}
            //         </ButtonGroup>
            //       </FormGroup>
            //     </Col>
            //     <Col md={4}>
            //       <FormGroup className="mb-0">
            //         <Label size="sm" className="d-block">{tx("projeler.projeYapisi")}</Label>
            //         <ButtonGroup>
            //           {SELECTABLE_PROJECT_TYPES.map((key) => {
            //             const meta = PROJECT_TYPE_META[key];
            //             return (
            //               <Button
            //                 key={key} type="button" size="sm" color="info"
            //                 outline={form.projectType !== key}
            //                 onClick={() => updateProjectType(key)}
            //               >
            //                 <meta.icon size={13} className="me-1" />{meta.label}
            //               </Button>
            //             );
            //           })}
            //         </ButtonGroup>
            //       </FormGroup>
            //     </Col>
            //     <Col md={4}>
            //       <FormGroup className="mb-0">
            //         <Label size="sm">{tx("projeler.projeTipi")}</Label>
            //         <Input
            //           type="select" bsSize="sm"
            //           value={form.projectStructure} disabled={!form.projectType}
            //           onChange={(e) => update("projectStructure", e.target.value)}
            //         >
            //           <option value="">{form.projectType ? tx("projeler.secin") : tx("projeler.onceProjeYapisiSecin")}</option>
            //           {(PROJECT_STRUCTURE_BY_TYPE[form.projectType] || []).map((key) => (
            //             <option key={key} value={key}>{PROJECT_STRUCTURE_META[key]}</option>
            //           ))}
            //         </Input>
            //       </FormGroup>
            //     </Col>
            //   </Row>
            )}
          </>
        )}

        {/* ═══ ADIM 3 — KONTROL ═══ */}
        {step === "kontrol" && (
          <>
            <div className="fw-semibold mb-2 d-flex align-items-center gap-2">
              {tx("projeler.uygunlukKontrolu")}
              {validating && <Spinner size="sm" color="secondary" />}
            </div>
            {/* Bu adımın tek amacı: yanlış bir tipi/alanı, YÜKSEKLİK SORULMADAN ÖNCE
                söylemek. Reddedilerek öğrenmek en kötü öğrenme biçimi. */}
            <div className="text-muted small mb-3">
              {tx("projeler.girdiginizAlanVeSectiginizStand")}
            </div>

            <Card className="border mb-3">
              <CardBody className="py-2">
                <Row className="g-2 small">
                  <Col md={6}>
                    <span className="text-muted">{tx("projeler.alan2")}</span>{" "}
                    <span className="fw-semibold">{form.m2 === "" ? tx("projeler.girilmedi") : `${form.m2} m²`}</span>
                  </Col>
                  <Col md={6}>
                    <span className="text-muted">{tx("projeler.standTipi2")}</span>{" "}
                    <span className="fw-semibold">
                      {effKural?.standTypeName ?? shell?.standTypeName ?? "—"}
                    </span>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {preCheck == null ? (
              <div className="text-center py-3"><Spinner color="primary" /></div>
            ) : preCheck.length === 0 ? (
              <Alert color="success" className="d-flex align-items-start gap-2">
                <ShieldCheck size={18} className="flex-shrink-0 mt-1" />
                <span>
                  {tx("projeler.burayaKadarBirSorunYok")}
                </span>
              </Alert>
            ) : (
              <>
                <KuralIhlalListesi
                  violations={preCheck}
                  title={tx("projeler.alanStandTipiBuFuarin")}
                />
                {preCheckBlocked && (
                  <div className="text-muted small">
                    {tx("projeler.devamEdebilmekIcinOncekiAdimlara")}
                    <span className="fw-semibold">{" "}{tx("projeler.projeYardimMerkezine")}</span>{" "}{tx("projeler.iletebileceksiniz")}
                  </div>
                )}
              </>
            )}

            <div className="mt-3">
              <Button color="secondary" outline size="sm" onClick={runPreCheck} disabled={validating}>
                <RefreshCw size={13} className="me-1" />{tx("projeler.yenidenKontrolEt")}
              </Button>
            </div>
          </>
        )}

        {/* ═══ ADIM 4 — YÜKSEKLİK VE DETAYLAR ═══ */}
        {step === "hmax" && (
          <>
            <div className="fw-semibold mb-2 d-flex align-items-center gap-2">
              {tx("projeler.yukseklikVeDetaylar")}
              {validating && <Spinner size="sm" color="secondary" />}
            </div>

            {/* Alan bazlı ihlaller ilgili inputun altında; kalanlar burada.
                HEPSİ gösterilir, ilki değil — backend kasıtlı olarak tümünü döner. */}
            <KuralIhlalListesi violations={violations} hideFields={INLINE_VIOLATION_FIELDS} />

            <Row className="g-3 mb-3">
              <Col md={6}>
                <FormGroup className="mb-0">
                  <Label size="sm">{tx("projeler.hMaxMaksimumDuvarYuksekligi")}{" "}<span className="text-danger">*</span></Label>
                  <Input
                    type="number" min="0" step="0.1" bsSize="sm" autoFocus
                    value={form.hMax} onChange={(e) => update("hMax", e.target.value)}
                  />
                  {/* Sınırı ATIFLI göster ("4,00 m — Ahşap standlar için"): atıfsız bir sayı
                      dekoratöre nereden geldiğini söylemiyor. heightLimit null ise hiçbir
                      yerde kayıt yok demek — "sınırsız" YAZMIYORUZ, hiçbir şey yazmıyoruz. */}
                  {isLive && describeHeightLimit(effKural) && (
                    <div className="text-muted small mt-1">
                      <Info size={12} className="me-1" />
                      {tx("projeler.izinVerilenMaksimum")}{" "}<span className="fw-semibold">{describeHeightLimit(effKural)}</span>
                    </div>
                  )}
                  {violationsFor("declaredHeightNumber").map((v, i) => (
                    <KuralIhlalSatiri key={i} violation={v} className="mt-1" />
                  ))}
                  <FieldWarning text={warnings.hMax} />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="mb-0">
                  <Label size="sm">{tx("projeler.projeAlaniM1Adimda")}</Label>
                  <Input
                    type="number" min="0" step="0.1" bsSize="sm"
                    value={form.m2} onChange={(e) => update("m2", e.target.value)}
                  />
                  {violationsFor("declaredAreaM2").map((v, i) => (
                    <KuralIhlalSatiri key={i} violation={v} className="mt-1" />
                  ))}
                </FormGroup>
              </Col>
            </Row>

            {/* ─── Malzeme / kullanım beyanı — SADECE fuarın sorduğu kurallar (katalog:
                cam, boya ve adminin eklediği diğerleri; 2026-09-17). sorulsun false ise
                soru hiç görünmez ve alan null gider ("hiç sorulmadı", false ile aynı şey
                değil). Fuar yasağa rağmen soruyor olabilir (sadece bilmek istiyordur) ya
                da sormadan yasaklamış olabilir — "sorulsun" ve "izinli" iki ayrı sorudur. ─── */}
            {isLive && sorulanKullanimlar.length > 0 && (
              <>
                <div className="fw-semibold mb-2">{tx("projeler.malzemeBeyani")}</div>
                <Row className="g-3 mb-4">
                  {sorulanKullanimlar.map((k) => (
                    <Col md={6} key={k.kod}>
                      <FormGroup switch className="mb-1">
                        <Input
                          type="switch" role="switch" id={`kullanim-${k.kod}`}
                          checked={form.kullanimlar?.[k.kod] === true}
                          onChange={(e) => updateKullanim(k.kod, e.target.checked)}
                        />
                        <Label check for={`kullanim-${k.kod}`}>
                          {k.beyanSorusu || tx("projeler.standimdaKullanilacak", { v: k.ad ?? k.kod })}
                        </Label>
                      </FormGroup>
                      {k.izinli === false && (
                        <div className="text-danger small d-flex align-items-start gap-1">
                          <AlertTriangle size={12} className="flex-shrink-0 mt-1" />
                          <span>{k.yasakMesaji || tx("projeler.buFuardaKullaniminaIzinVerilmiyor", { v: k.ad ?? k.kod })}</span>
                        </div>
                      )}
                      {kullanimViolationFields(k.kod).flatMap(violationsFor).map((v, i) => (
                        <KuralIhlalSatiri key={i} violation={v} className="mt-1" />
                      ))}
                    </Col>
                  ))}
                </Row>
              </>
            )}

            {/* ⚠️ Teknik Talepler + kW bloğu 2026-08-29'da BURADAN ALINDI ve 8. adıma
                (Kuşbakışı/Teknik Talep Planı) taşındı — belge, talep ve kW aynı ekranda
                sorulsun diye. Bkz. dosya başındaki "kW'nin yeri" notu. */}

            {/* ─── Proje Yardım Merkezi (eski adıyla Özel İzin, 2026-08-28) ─── */}
            {canRequestPermit && (
              <Card className="border border-warning mb-3">
                <CardBody className="py-3">
                  <div className="fw-semibold mb-1 d-flex align-items-center gap-2">
                    <ShieldCheck size={16} className="text-warning" />
                    {tx("projeler.kuralaAykiriAmaZorunluMu")}
                  </div>
                  <div className="text-muted small mb-2">
                    {tx("projeler.yukaridakiMaddelerBeyaniniziNormaldeReddettirir")}{" "}<span className="fw-semibold">{tx("projeler.kaydedipProjeYardimMerkezineIletebilirsiniz")}</span>{tx("projeler.talebinizKararaBaglananaKadarProjeniz")}
                  </div>
                  <FormGroup check className="mb-2">
                    <Input
                      type="checkbox" checked={ozelIzinTalep}
                      onChange={(e) => setOzelIzinTalep(e.target.checked)}
                    />
                    <Label check>{tx("projeler.buSekildeKaydetVeProje")}</Label>
                  </FormGroup>
                  {ozelIzinTalep && (
                    <FormGroup className="mb-0">
                      <Label size="sm">{tx("projeler.gerekceniz")}</Label>
                      <Input
                        type="textarea" rows={2} value={ozelIzinNotu} maxLength={OZEL_IZIN_NOT_MAX}
                        onChange={(e) => setOzelIzinNotu(e.target.value)}
                        placeholder={tx("projeler.ornUrunumuz520M")}
                      />
                      {/* Denetmenin sayılar dışında elindeki tek şey bu. */}
                      <div className="text-muted small mt-1">
                        {tx("projeler.denetmeninKarariVerirkenSayilarDisinda", { length: ozelIzinNotu.length, OZEL_IZIN_NOT_MAX })}
                      </div>
                    </FormGroup>
                  )}
                </CardBody>
              </Card>
            )}

            {/* İzin verilemeyen ihlaller — bayrak bunları KURTARMAZ, o yüzden
                seçenek yerine ne yapılması gerektiğini yazıyoruz. */}
            {blockers.length > 0 && (
              <Alert color="danger" className="small">
                <AlertTriangle size={15} className="me-1" />
                {tx("projeler.asagidakiMaddelerIcin")}{" "}<span className="fw-semibold">{tx("projeler.istisnaTaninamaz")}</span>{tx("projeler.beyanAncakDuzeltildiktenSonraKaydedilebilir")}
                <ul className="mb-0 mt-1">
                  {blockers.map((v, i) => <li key={i}>{v.message}</li>)}
                </ul>
              </Alert>
            )}

            <Alert color="warning" className="mb-0 small d-flex align-items-start gap-2">
              <AlertTriangle size={16} className="flex-shrink-0 mt-1" />
              <span>{tx("projeler.beyanUyarisi")}</span>
            </Alert>
          </>
        )}

        {/* ═══ ADIM 5 — DUVARLAR ═══ */}
        {step === "duvarlar" && (
          <>
            {/* Beyan bu noktada KAYDEDİLDİ. Bunu söylemezsek kullanıcı pencereyi
                kapatınca her şeyi kaybettiğini sanır. */}
            <Alert color={permitPending ? "warning" : "success"} className="d-flex align-items-start gap-2">
              {permitPending
                ? <ShieldCheck size={18} className="flex-shrink-0 mt-1" />
                : <CheckCircle2 size={18} className="flex-shrink-0 mt-1" />}
              <span>
                {permitPending ? (
                  <>
                    {tx("projeler.beyaninizKaydedildiVe")}{" "}<span className="fw-semibold">{tx("projeler.projeYardimMerkezineIletildi")}</span>{tx("projeler.birDenetmenKararVereneKadar")}
                  </>
                ) : (
                  <>
                    <span className="fw-semibold">{tx("projeler.beyaninizKaydedildi")}</span>{" "}{tx("projeler.bundanSonrakiAdimlarAyriKayitlardir")}
                  </>
                )}
              </span>
            </Alert>

            {/* Onaylı izin sonrası ihlaller PERMITTED olarak listede kalır; bu kutu
                onları da doğru tonda basar. */}
            <KuralIhlalListesi violations={violations} title={tx("projeler.beyaninizdakiKuralDurumu")} />

            <div className="fw-semibold mb-1">{tx("projeler.duvarBilgisi")}</div>
            {canliDuvarlar && (
              <>
                <FieldWarning text={warnings.kroki} />
                {/* #676: standın çizimindeki her kenar için bir satır; çizilmemiş stand için elle yazılan liste. */}
                <CizilenDuvarlarFormu
                  veri={cizilen} yukleniyor={cizilenYukleniyor || (cizilen == null && !cizilenHata)} hata={cizilenHata}
                  satirlar={duvarSatirlari} ihlaller={wallViolations}
                  onDegis={handleDuvarSatiriDegis} onEkle={handleDuvarSatiriEkle} onSil={handleDuvarSatiriSil}
                />

                {/* Reddedilen listede izin verilebilir ihlal varsa: beyan adımındaki Proje Yardım Merkezi yolu. */}
                {canRequestWallPermit && (
                  <Card className="border border-warning mb-3">
                    <CardBody className="py-3">
                      <div className="fw-semibold mb-1 d-flex align-items-center gap-2">
                        <ShieldCheck size={16} className="text-warning" />
                        {tx("projeler.kuralaAykiriAmaZorunluMu")}
                      </div>
                      <div className="text-muted small mb-2">
                        {tx("projeler.yukaridakiMaddelerBeyaniniziNormaldeReddettirir")}{" "}<span className="fw-semibold">{tx("projeler.kaydedipProjeYardimMerkezineIletebilirsiniz")}</span>{tx("projeler.talebinizKararaBaglananaKadarProjeniz")}
                      </div>
                      <FormGroup check className="mb-2">
                        <Input
                          type="checkbox" checked={wallOzelIzinTalep}
                          onChange={(e) => setWallOzelIzinTalep(e.target.checked)}
                        />
                        <Label check>{tx("projeler.buSekildeKaydetVeProje")}</Label>
                      </FormGroup>
                      {wallOzelIzinTalep && (
                        <FormGroup className="mb-0">
                          <Label size="sm">{tx("projeler.gerekceniz")}</Label>
                          <Input
                            type="textarea" rows={2} value={wallOzelIzinNotu} maxLength={OZEL_IZIN_NOT_MAX}
                            onChange={(e) => setWallOzelIzinNotu(e.target.value)}
                          />
                          <div className="text-muted small mt-1">
                            {tx("projeler.denetmeninKarariVerirkenSayilarDisinda", { length: wallOzelIzinNotu.length, OZEL_IZIN_NOT_MAX })}
                          </div>
                        </FormGroup>
                      )}
                    </CardBody>
                  </Card>
                )}
                {wallBlockers.length > 0 && (
                  <Alert color="danger" className="small">
                    <AlertTriangle size={15} className="me-1" />
                    {tx("projeler.asagidakiMaddelerIcin")}{" "}<span className="fw-semibold">{tx("projeler.istisnaTaninamaz")}</span>{tx("projeler.beyanAncakDuzeltildiktenSonraKaydedilebilir")}
                  </Alert>
                )}
              </>
            // WAS (until #713): the mock wall form (WallDimensionsKroki + per-wall width/height inputs); the drawn-walls form above is the only path:
            // ) : (
            //   <>
            // <div className="text-muted small mb-2">
            //   {tx("projeler.krokidekiNumaraliNoktalaraTiklayarakHer")}{" "}<span className="fw-semibold">{tx("projeler.genisliginiVeYuksekligini")}</span>{" "}{tx("projeler.girinBuListeStandinizinBeyanidir")}
            // </div>
            // <FieldWarning text={warnings.kroki} />
            // <Row className="g-3 align-items-center mb-3">
            //   <Col md="auto" className="d-flex justify-content-center">
            //     <WallDimensionsKroki
            //       wallWidths={form.wallWidths} wallHeights={form.wallHeights}
            //       activeWall={activeWall} onSelectWall={setActiveWall} size={130}
            //     />
            //   </Col>
            //   <Col>
            //     {activeWall != null ? (
            //       <div style={{ maxWidth: 220 }}>
            //         {/* Genişlik önce sorulur — yükseklikten daha önemli kabul edildiği için
            //             (bkz. dosya başı 2026-07-31 "duvar genişliği" notu). */}
            //         <FormGroup className="mb-2">
            //           <Label size="sm">{tx("projeler.duvarGenisligiM", { activeWall })}</Label>
            //           <Input
            //             type="number" min="0" step="0.1" bsSize="sm" autoFocus
            //             value={form.wallWidths[activeWall] ?? ""}
            //             onChange={(e) => updateWallWidth(activeWall, e.target.value)}
            //           />
            //         </FormGroup>
            //         <FormGroup className="mb-0">
            //           <Label size="sm">{tx("projeler.duvarYuksekligiM", { activeWall })}</Label>
            //           <Input
            //             type="number" min="0" step="0.1" bsSize="sm"
            //             value={form.wallHeights[activeWall] ?? ""}
            //             onChange={(e) => updateWallHeight(activeWall, e.target.value)}
            //           />
            //         </FormGroup>
            //       </div>
            //     ) : (
            //       <div className="text-muted small">{tx("projeler.krokidekiNumaraliNoktalardanBirineTiklayarak")}</div>
            //     )}
            //   </Col>
            // </Row>

            // {/* Backend her duvarın İKİ ölçüsünü de > 0 istiyor; yarım bırakılmış bir
            //     duvar 400 döner. Kullanıcıya kaydetmeden söylüyoruz. */}
            // {wallRows.length > 0 && !wallsComplete && (
            //   <Alert color="warning" className="small mb-2">
            //     {tx("projeler.herDuvarinHemGenisligiHem")}
            //     {wallRows.filter((w) => !(Number(w.width) > 0 && Number(w.height) > 0))
            //       .map((w) => w.id).join(", ")}
            //   </Alert>
            // )}
            //   </>
            )}
            {wallsSaved && (
              <Alert color="success" className="small mb-2">{tx("projeler.duvarBilgisiKaydedildi")}</Alert>
            )}
            <div className="text-muted small">
              {tx("projeler.duvarListesi")}{" "}<span className="fw-semibold">{tx("projeler.toptanDegisir")}</span>{tx("projeler.yenidenGonderdiginizdeOncekiListeTamamen")}
            </div>
          </>
        )}

        {/* ═══ ADIM 6 — FUARIN EK FORMLARI ═══ */}
        {step === "formlar" && (
          <>
            <div className="fw-semibold mb-2">{tx("projeler.buFuarinEkBeyanFormlari")}</div>
            {/* zorunlu BEYANI değil KABULÜ engeller. Bunu yazmazsak dekoratör
                "beyanım geçti mi geçmedi mi?" diye takılır. */}
            <div className="text-muted small mb-3">
              {tx("projeler.beyaninizKaydedildiBuFuarAyrica")}
              <span className="fw-semibold">{" "}{tx("projeler.zorunlu")}</span>{" "}{tx("projeler.isaretliOlanlarDoldurulmadanBeyaninizInceleme")}{" "}<span className="fw-semibold">{tx("projeler.kabulEdilemez")}</span>{" "}{tx("projeler.beyaniniziVermeniziEngellemezlerKabuluBekletirle")}
            </div>

            {formsLoading ? (
              <div className="text-center py-3"><Spinner /></div>
            ) : beyanFormlari.length === 0 ? (
              <Alert color="secondary">{tx("projeler.buFuarinEkBeyanFormu")}</Alert>
            ) : (
              <div className="d-flex flex-column gap-2 mb-3">
                {beyanFormlari.map((f) => (
                  <Card key={f.id} className={`border ${f.zorunlu && !f.filled ? "border-warning" : ""}`}>
                    <CardBody className="py-2 d-flex align-items-center justify-content-between gap-2 flex-wrap">
                      <div>
                        <div className="fw-semibold">
                          {f.formAdi ?? tx("projeler.form", { id: f.id })}
                          {f.zorunlu && <Badge color="danger" className="ms-2">{tx("projeler.zorunlu")}</Badge>}
                          {/* Tanımı bulunamayan form GİZLENMEZ: zorunluysa kimsenin
                              açamayacağı bir şeyi bekliyoruz demektir, bunu görmek gerek. */}
                          {f.formMissing && <Badge color="danger" className="ms-2">{tx("projeler.tanimiBulunamadi")}</Badge>}
                        </div>
                        <div className="text-muted small">
                          <Badge color={BEYAN_FORM_TIPI[f.formTipi]?.color ?? "secondary"} className="me-2">
                            {f.formTipiAdi ?? BEYAN_FORM_TIPI[f.formTipi]?.label ?? `#${f.formTipi}`}
                          </Badge>
                          {f.completionKnown && (f.filled
                            ? <span className="text-success">{tx("projeler.dolduruldu")}</span>
                            : <span className="text-muted">{tx("projeler.henuzDoldurulmadi")}</span>)}
                        </div>
                      </div>
                      {/* Formu AÇMAK tipe göre farklı yerlere gidiyor: tip 1 projenin
                          sürdürülebilirlik alt belgesi, tip 2 ayrı bir serbest form
                          submission'ı, tip 3 (PDF, backlog #92/#93) doğrudan indirme —
                          bilgilendirme amaçlıdır, doldurma akışı yok. */}
                      {f.formTipi === 1 ? (
                        // #712: the company's own page for the project's form (new tab, ?geri= brings it back to this list).
                        // WAS: href={shell?.id ? `/Management/Projects/${shell.id}/sustainability` : "/FdsSaha/Sustainability"} -- a staff-only route,
                        // and a mock form that never reaches the project.
                        <Button
                          color="success" outline size="sm" tag="a" target="_blank" rel="noopener noreferrer"
                          href={`/Firma/Projeler/${shell.id}/surdurulebilirlik?${new URLSearchParams({ geri: "/Firma/Projeler", geriEtiket: tx("projeler.projelereDon") })}`}
                        >
                          <Leaf size={14} className="me-1" />{f.filled ? tx("common:goruntule") : tx("projeler.doldur")}
                        </Button>
                      ) : f.formTipi === 3 ? (
                        <Button
                          color="secondary" outline size="sm" tag="a" target="_blank" rel="noopener noreferrer"
                          href={f.formUrl} disabled={f.formMissing}
                        >
                          <i className="bx bx-download me-1" />{tx("projeler.pdfIIndir")}
                        </Button>
                      ) : f.filled || f.formMissing ? null : (
                        // #712: every free-form endpoint is staff-only for now (backend #422: page.saha), so a company has nothing to open.
                        // WAS: a link to /FdsSaha/FreeFormFill?templateId=... (no such route) and /FdsSaha/FreeFormSubmissions (staff page).
                        <span className="text-muted small">{tx("projeler.serbestFormSakaDoldurur")}</span>
                      )}
                    </CardBody>
                  </Card>
                ))}
              </div>
            )}

            {blockingDeclarationForms(beyanFormlari).length > 0 && (
              <Alert color="warning" className="small mb-0">
                <AlertTriangle size={15} className="me-1" />
                {tx("projeler.doldurulmamisZorunluFormVarBeyaniniz")}
              </Alert>
            )}
          </>
        )}

        {/* ══════════════════ PROJE BELGELERİ YARISI (adım 7-10) ══════════════════
            Beyan bitti; buradan sonrası opsiyonel ve Stand Detayı sayfasından da
            yapılabilir. Bunu HER belge adımında tekrarlıyoruz: pencereyi kapatan
            dekoratör "beyanım yarım mı kaldı?" diye endişelenmesin. */}
        {inBelgePhase && (
          <Alert color="success" className="d-flex align-items-start gap-2">
            <CheckCircle2 size={18} className="flex-shrink-0 mt-1" />
            <span>
              <span className="fw-semibold">{tx("projeler.beyaninizTamamlandi")}</span>{" "}{tx("projeler.bundanSonrasi")}
              <span className="fw-semibold">{tx("projeler.projeBelgeleri2")}</span>{" "}{tx("projeler.herAdimOpsiyoneldirVeIstediginiz")}{" "}<span className="fw-semibold">{tx("projeler.standDetayiProjeDosyalari")}</span>{" "}
              {tx("projeler.sekmesindenDevamEdebilirsiniz")}
            </span>
          </Alert>
        )}

        {/* ═══ ADIM 7 — PROJE GÖRSELLERİ (4 KÖŞE) ═══ */}
        {step === "gorseller" && (
          <>
            <div className="fw-semibold mb-2">{tx("projeler.projeGorselleriDortKose")}</div>
            <div className="text-muted small mb-3">
              {tx("projeler.standinizin")}{" "}<span className="fw-semibold">{tx("projeler.dortKosesinden")}</span>{" "}{tx("projeler.cekilmisRenderEdilmisGorselleriYukleyin")}
            </div>
            {koseler === null && <Spinner size="sm" />}
            {koseler?.length === 0 && (
              <Alert color="danger" className="mb-0">{tx("projeler.koseTurleriCozulemedi")}</Alert>
            )}
            {koseler?.length > 0 && (
              <Row className="g-3">
                {koseler.map((subStandFileId, i) => {
                  const key = `gorsel-${subStandFileId}`;
                  return (
                    <Col md={3} sm={6} key={key}>
                      <BelgeYuklemeKutusu
                        label={tx("projeler.koseN", { n: i + 1 })}
                        slot={yuva(key, BELGE_IDS.gorseller, subStandFileId)}
                        uploading={uploadingKey === key}
                        onUpload={(f) => handleBelgeUpload(key, BELGE_IDS.gorseller, f, subStandFileId)}
                      />
                    </Col>
                  );
                })}
              </Row>
            )}
          </>
        )}

        {/* ═══ ADIM 8 — TEKNİK TALEPLER ═══ */}
        {step === "talepler" && (
          <>
            <div className="fw-semibold mb-1">
              {tx("projeler.talepEdeceginizTeknikTalepler")}{" "}<span className="text-muted fw-normal">{tx("projeler.opsiyonel")}</span>
            </div>
            <div className="text-muted small mb-2">
              {tx("projeler.elektrikIcinKWCinsindenMiktar")}{" "}<span className="fw-semibold">{tx("projeler.herKalemIkiAdimSonra")}</span>{tx("projeler.buAsamadaBosKapaliBirakirsaniz")}
            </div>
            <FieldWarning text={warnings.teknikTalepler} />
            <Row className="g-3 mb-3">
              {TEKNIK_TALEP_KATEGORILERI.map((cat) => {
                const Icon = TEKNIK_ICONS[cat.key];
                if (cat.type === "quantity") {
                  const enabledKey = `${cat.key}Enabled`;
                  return (
                    <Col md={3} key={cat.key}>
                      <FormGroup switch className="mb-1">
                        <Input
                          type="switch" role="switch"
                          checked={form[enabledKey]}
                          onChange={(e) => { update(enabledKey, e.target.checked); setTeknikSaved(false); }}
                        />
                        <Label check className="d-flex align-items-center gap-1">
                          <Icon size={13} />{cat.label}{" "}{tx("projeler.kW")}
                        </Label>
                      </FormGroup>
                      <Input
                        type="number" min="0" step="1" bsSize="sm" disabled={!form[enabledKey]}
                        value={form[cat.key]}
                        onChange={(e) => { update(cat.key, e.target.value); setTeknikSaved(false); }}
                        invalid={cat.key === "elektrik" && elektrikKwEksik}
                      />
                      {cat.key === "elektrik" && elektrikKwEksik && (
                        <div className="text-danger small mt-1">{tx("projeler.elektrikIcinKWGirin")}</div>
                      )}
                      {/* Serbest kW hakkı — aşmak beyanı ENGELLEMEZ, ücretlendirilir.
                          O yüzden ihlali de WARNING olarak geliyor ve gönder düğmesini
                          kapatmıyor. Kademeli fuarlarda hak m²'ye göre çözülüyor. */}
                      {isLive && cat.key === "elektrik" && effKural && (
                        <FreeKwHint eff={effKural} m2={form.m2} />
                      )}
                      {cat.key === "elektrik" && violationsFor("declaredKw").map((v, i) => (
                        <KuralIhlalSatiri key={i} violation={v} className="mt-1" />
                      ))}
                    </Col>
                  );
                }
                return (
                  <Col md={3} key={cat.key} className="d-flex align-items-end">
                    <FormGroup switch className="mb-0">
                      <Input
                        type="switch" role="switch"
                        checked={form[cat.key]}
                        onChange={(e) => { update(cat.key, e.target.checked); setTeknikSaved(false); }}
                      />
                      <Label check className="d-flex align-items-center gap-1">
                        <Icon size={13} />{cat.label}
                      </Label>
                    </FormGroup>
                  </Col>
                );
              })}
            </Row>

            {/* kW'yi beyana işlemek ikinci bir /declare demek ve o çağrı canlı özel
                izinleri geçersiz kılıyor — izin varken kararı kullanıcı verir. */}
            {izinRiskte && kwDegisti && (
              <Card className="border border-warning mb-3">
                <CardBody className="py-3">
                  <div className="fw-semibold mb-1 d-flex align-items-center gap-2">
                    <ShieldCheck size={16} className="text-warning" />
                    {tx("projeler.buProjedeAcikBirYardim")}
                  </div>
                  <div className="text-muted small mb-2">
                    {tx("projeler.kWYi")}{" "}<span className="fw-semibold">{tx("projeler.beyaniniza")}</span>{" "}{tx("projeler.islemekBeyaniYenidenGondermekDemektir")}
                    <span className="fw-semibold">{tx("projeler.mevcutYardimMerkeziTalebiniziGecersiz")}</span>{tx("projeler.istersenizKWYalnizcaTeknikTalep")}
                  </div>
                  <FormGroup check className="mb-0">
                    <Input
                      type="checkbox" checked={kwSadeceTalep}
                      onChange={(e) => setKwSadeceTalep(e.target.checked)}
                    />
                    <Label check>{tx("projeler.kWYiSadeceTeknikTalebe")}</Label>
                  </FormGroup>
                </CardBody>
              </Card>
            )}

            {teknikSaved && (
              <Alert color="success" className="small mb-0">
                {tx("projeler.teknikTaleplerinizKaydedildi")}{kwYenidenBeyan ? tx("projeler.veKWBeyaninizaIslendi") : ""}.
                {teknikTaslak && (
                  <div className="mt-1" data-testid="beyan-teknik-taslak">
                    {tx("projeler.teknikTaslakNotu")}{" "}
                    <a href={`/Firma/Talepler/${record.id}?tab=teknikTalepler`} target="_blank" rel="noreferrer" className="fw-semibold">
                      {tx("projeler.taleplerSayfasinaGit")}
                    </a>
                  </div>
                )}
              </Alert>
            )}
          </>
        )}

        {/* ═══ ADIM 9 — KUŞBAKIŞI / TEKNİK TALEP PLANI ═══ */}
        {step === "plan" && (
          <>
            <div className="fw-semibold mb-2">{tx("projeler.kusbakisiTeknikTalepPlani")}</div>
            <div className="text-muted small mb-3">
              {tx("projeler.kusbakisiCiziminizAyniZamanda")}{" "}<span className="fw-semibold">{tx("projeler.teknikTalepPlaninizdir")}</span>{tx("projeler.birOncekiAdimdaIsaretlediginizKalemlerin")}
            </div>
            <Row className="g-3">
              <Col md={5}>
                <BelgeYuklemeKutusu
                  label={tx("projeler.kusbakisiTeknikTalepPlani2")}
                  slot={planSlot}
                  height={140}
                  uploading={uploadingKey === "plan"}
                  onUpload={(f) => handleBelgeUpload("plan", BELGE_IDS.plan, f, null, { plan: true })}
                />
              </Col>
              <Col md={7} className="d-flex align-items-center">
                {planYuklu ? (
                  <div className="text-muted small">
                    <Check size={14} className="text-success me-1" />
                    {tx("projeler.planinizYuklendiCikisNoktalariniBir")}
                  </div>
                ) : (
                  <Alert color="warning" className="small mb-0">
                    <AlertTriangle size={15} className="me-1" />
                    {tx("projeler.planYuklenmedenCikisNoktasiIsaretlenemez")}
                  </Alert>
                )}
              </Col>
            </Row>
          </>
        )}

        {/* ═══ ADIM 10 — ÇIKIŞ NOKTALARI ═══ */}
        {step === "cikis" && (
          <>
            <div className="fw-semibold mb-2">{tx("projeler.cikisNoktalari")}</div>
            <div className="text-muted small mb-3">
              {tx("projeler.talepEttiginizHerKalemIcin")}
              <span className="fw-semibold">{tx("projeler.teknikTalepPlaninaBakarak")}</span>{" "}{tx("projeler.krokideCikisNoktasiniIsaretleyinSolda")}
            </div>

            {talepEdilenKategoriler.length === 0 ? (
              <Alert color="secondary">
                {tx("projeler.teknikTaleplerAdimindaHicbirKalem")}
              </Alert>
            ) : (
              <div className="d-flex flex-column gap-3">
                {talepEdilenKategoriler.map((cat) => (
                  <CikisNoktasiPinner
                    key={cat.key}
                    category={cat}
                    icon={TEKNIK_ICONS[cat.key]}
                    planFile={planSlot.file}
                    planUrl={planSlot.url}
                    localPreviewUrl={planSlot.localUrl}
                    kontur={cizimKontur}
                    value={points[cat.key] ?? null}
                    onChange={(p) => { setPoints((prev) => ({ ...prev, [cat.key]: p })); setPointsSaved(false); }}
                  />
                ))}
              </div>
            )}

            {pointsSaved && (
              <Alert color="success" className="small mb-0 mt-3">{tx("projeler.cikisNoktalariKaydedildi")}</Alert>
            )}
          </>
        )}

        {/* ═══ ADIM 11 — STATİK HESAP (koşullu) ═══ */}
        {step === "statik" && (
          <>
            <div className="fw-semibold mb-2">{tx("projeler.statikHesap")}</div>
            <div className="text-muted small mb-3">
              {tx("projeler.buStandinBelgeKurallari")}{" "}<span className="fw-semibold">{tx("projeler.statikHesap2")}</span>{" "}{tx("projeler.istiyorYukseklikStandTipiKombinasyonunuz")}
            </div>
            <Row className="g-3">
              <Col md={5}>
                <BelgeYuklemeKutusu
                  label={tx("projeler.statikHesap")}
                  slot={yuva("statik", BELGE_IDS.statik)}
                  height={140}
                  uploading={uploadingKey === "statik"}
                  onUpload={(f) => handleBelgeUpload("statik", BELGE_IDS.statik, f)}
                />
              </Col>
            </Row>
          </>
        )}
      </ModalBody>
      <ModalFooter>
        {/* Beyan gönderilmeden önce "Vazgeç", sonrasında "Kapat" — sonrasında
            iptal edilecek bir şey yok, beyan zaten kaydedildi. */}
        <Button color="secondary" outline onClick={handleClose} disabled={submitting}>
          {declareSent ? tx("common:kapat") : tx("projeler.vazgec")}
        </Button>
        {/* "Geri" beyan yarısında YALNIZCA beyan gönderilmeden önce açıktır (gönderdikten
            sonra geri dönmek yeni bir /declare demek olurdu). Belge yarısında ise serbest:
            orada geri gitmek hiçbir şeyi yeniden yazmaz, sadece adımı değiştirir. */}
        {stepIndex > 0 && (inBelgePhase || !declareSent) && (
          <Button
            color="secondary" outline disabled={submitting}
            onClick={() => setStep(STEPS[stepIndex - 1].key)}
          >
            <ArrowLeft size={14} className="me-1" />{tx("common:geri")}
          </Button>
        )}

        {step === "hmax" ? (
          <Button color="success" onClick={handleDeclare} disabled={!canSubmitDeclare}>
            {submitting ? <Spinner size="sm" className="me-1" /> : <Upload size={14} className="me-1" />}
            {canRequestPermit && ozelIzinTalep ? tx("projeler.kaydetVeYardimMerkezineIlet") : tx("projeler.beyaniGonder")}
          </Button>
        ) : null}

        {step === "duvarlar" && (
          // WAS (until #676): <Button color="success" onClick={handleSaveWalls} disabled={submitting || !wallsComplete}>
          <Button color="success" onClick={handleSaveWalls} disabled={submitting || !duvarKaydedilebilir}>
            {submitting ? <Spinner size="sm" className="me-1" /> : <Upload size={14} className="me-1" />}
            {canRequestWallPermit && wallOzelIzinTalep ? tx("projeler.kaydetVeYardimMerkezineIlet") : tx("projeler.duvarBilgisiniKaydet")}
          </Button>
        )}

        {step === "talepler" && (
          <Button color="success" onClick={handleSaveTeknik} disabled={submitting || elektrikKwEksik}>
            {submitting ? <Spinner size="sm" className="me-1" /> : <Upload size={14} className="me-1" />}
            {tx("projeler.teknikTalepleriKaydet")}
          </Button>
        )}

        {step === "cikis" && talepEdilenKategoriler.length > 0 && (
          <Button
            color="success" onClick={handleSavePoints}
            disabled={submitting || !planYuklu || !talepEdilenKategoriler.some((c) => points[c.key])}
          >
            {submitting ? <Spinner size="sm" className="me-1" /> : <MapPin size={14} className="me-1" />}
            {tx("projeler.cikisNoktalariniKaydet")}
          </Button>
        )}

        {/* Beyanın SON adımı: yarı değiştiren tek düğme. "Kapat" ile burada bırakmak
            da geçerli bir sonuçtur — beyan zaten kaydedildi (bkz. dosya başı notu). */}
        {isLastBeyanStep && declareSent ? (
          <Button color="primary" disabled={submitting} onClick={enterBelgeYarisi}>
            <FolderUp size={14} className="me-1" />{tx("projeler.projeBelgelerineGec")}
          </Button>
        ) : step !== "hmax" ? (
          /* "duvarlar" adımında bu düğme eski "Şimdilik Atla"nın yerini tutar:
             duvar bilgisi opsiyonel, kaydetmeden ilerlemek serbest. */
          <Button
            color="primary"
            disabled={!stepValid || submitting || (step === "kontrol" && preCheck == null)}
            onClick={() => {
              if (isLastStep) { onCreated(); return; }
              const nextKey = STEPS[stepIndex + 1].key;
              if (nextKey === "kontrol") enterKontrol();
              else setStep(nextKey);
            }}
          >
            {isLastStep ? <><Check size={14} className="me-1" />{tx("projeler.bitir")}</> : <>{tx("projeler.devam")}<ArrowRight size={14} className="ms-1" /></>}
          </Button>
        ) : null}
      </ModalFooter>
    </Modal>
  );
}

/**
 * Serbest kW ipucu. Fuar SABİT bir hak veriyorsa doğrudan yazılır; KADEMELİ ya da
 * BLOK ise hak m²'ye bağlıdır ve m² girilmemişse hesaplanamaz.
 * ⚠️ Hiçbir kademeye düşmeyen stand hak ALMAZ ve UYARI DA ALMAZ — bu "0 kW" değil
 *    "hesaplayamıyorum" demektir, o yüzden "0 kW" yazmıyoruz.
 */
function FreeKwHint({ eff, m2 }) {
  const { t } = useTranslation("portal");
  const bands = eff?.serbestKwKademeleri ?? [];
  const flat = eff?.serbestKw;

  // BLOK modu (2026-09-17, backend #53): her TAM {blokM2} m² için {blokKw} kW.
  // Yarım blok sayılmaz (floor); alan yoksa hak da yok — "0 kW" değil "hesaplanamıyor".
  if (eff?.serbestKwMode === "BLOCK") {
    const blokKw = eff.serbestKwBlokKw == null ? null : Number(eff.serbestKwBlokKw);
    const blokM2 = eff.serbestKwBlokM2 == null ? null : Number(eff.serbestKwBlokM2);
    if (!(blokKw > 0) || !(blokM2 > 0)) return null;
    const area = m2 === "" || m2 == null ? null : Number(m2);
    // Ondalık blokKw'de (ör. 1,5) kayan nokta kırıntısı basılmasın diye 2 haneye yuvarlanır.
    const hak = area != null && area > 0 ? Math.round(Math.floor(area / blokM2) * blokKw * 100) / 100 : null;
    return (
      <div className="text-muted small mt-1">
        {t("projeler.serbestHakHerMIcin", { blokM2, blokKw })}
        {hak != null
          ? <> → <span className="fw-semibold">{hak}{" "}{t("projeler.kW2")}</span>{" "}{t("projeler.ustuUcretlendirilir")}</>
          : t("projeler.alanGirildigindeHesaplanacak")}
      </div>
    );
  }

  if (flat == null && bands.length === 0) return null;

  if (bands.length > 0) {
    const area = m2 === "" || m2 == null ? null : Number(m2);
    const band = bands.find((b) => {
      if (b.minM2 == null && b.maxM2 == null) return true;
      if (area == null) return false;
      return (b.minM2 == null || area >= Number(b.minM2)) && (b.maxM2 == null || area < Number(b.maxM2));
    });
    if (!band) {
      return (
        <div className="text-muted small mt-1">
          {t("projeler.serbestHakMYeGore")}{area == null ? t("projeler.alanGirildigindeHesaplanacak") : t("projeler.buAlanIcinTanimliBir")}
        </div>
      );
    }
    return (
      <div className="text-muted small mt-1">
        {t("projeler.serbestHak")}{" "}<span className="fw-semibold">{band.serbestKw}{" "}{t("projeler.kW2")}</span>{" "}
        ({band.minM2 ?? 0}–{band.maxM2 ?? "∞"}{" "}{t("projeler.mIcinUstuUcretlendirilir")}
      </div>
    );
  }
  return (
    <div className="text-muted small mt-1">
      {t("projeler.serbestHak")}{" "}<span className="fw-semibold">{flat}{" "}{t("projeler.kW2")}</span>{" "}{t("projeler.ustuUcretlendirilir")}
    </div>
  );
}


/**
 * Proje Özel İzni rozetleri + "Proje Yardım Merkezine İlet" düğmesi (2026-08-28).
 *
 * 2026-09-04: dekoratöre gösterilen AD değişti — "Özel İzin" katılımcı için fazla
 * hukuki/kapalı bir terimdi, ekranda artık "Proje Yardım Merkezi"ne iletme olarak
 * geçiyor. Değişen SADECE bu sayfadaki kopya: uç (POST /projects/{id}/ozel-izin),
 * alan adları (ozelIzinBekliyor/ozelIzinli/ozelIzinNotu) ve denetmen tarafındaki
 * "Özel İzinler" ekranı aynı kaldı — orası kararı veren tarafın dili.
 *
 * Üç farklı şey gösteriyor ve üçü de ayrı anlama geliyor:
 *  · ozelIzinBekliyor → talep açık, proje KİLİTLİ, kimse bir şey yapamaz
 *  · ozelIzinli       → onaylı bir izin ihlalleri temizliyor. İhlaller HÂLÂ listede
 *                         (PERMITTED) — "sorun kalmadı" DEĞİL, "imzalandı" demek
 *  · ozelIzinTalepEdilebilir → bir iznin temizleyebileceği en az bir ERROR var ve
 *                         ortada bekleyen/onaylı bir izin yok. Düğmenin doğru kapısı budur;
 *                         kendimiz türetmiyoruz.
 *
 * ⚠️ Burada ASLA Onayla/Reddet yok. Backend yetki kontrolü yapmıyor (guide §8.2) —
 *    katılımcı ekranına karar düğmesi koymak, kendi iznini onaylamasının önünde
 *    hiçbir engel bırakmazdı.
 */
function OzelIzinDurumu({ pb, onRequest }) {
  const { t } = useTranslation("portal");
  if (!pb) return null;
  if (pb.ozelIzinBekliyor) {
    return (
      <Badge color="warning" className="d-flex align-items-center gap-1">
        <ShieldCheck size={12} />{t("projeler.yardimMerkezindeInceleniyor")}
      </Badge>
    );
  }
  if (pb.ozelIzinli) {
    return (
      <Badge color="info" className="d-flex align-items-center gap-1" title={t("projeler.yardimMerkeziOnayladiIhlallerListede")}>
        <ShieldCheck size={12} />{t("projeler.yardimMerkeziOnayladi")}
      </Badge>
    );
  }
  // #425: onRequest yoksa (Katılımcı satırı — projeyi yalnızca izler) istek düğmesi çizilmez. WAS: if (pb.ozelIzinTalepEdilebilir) {
  if (pb.ozelIzinTalepEdilebilir && onRequest) {
    return (
      <Button color="warning" outline size="sm" onClick={onRequest}
        title={t("projeler.beyaninizBirKuraliCigniyorProje")}>
        <ShieldCheck size={14} className="me-1" />{t("projeler.projeYardimMerkezineIlet")}
      </Button>
    );
  }
  return null;
}

/**
 * KAYITLI bir beyanı Proje Yardım Merkezine iletme — POST /projects/{id}/ozel-izin.
 *
 * Normal yol beyan formundaki bayraktır (kaydet + iste, tek çağrı). Bu ekran onun
 * KAPSAYAMADIĞI durum için: kabul edildiğinde yasal olan bir beyanın, organizatör
 * tavanı düşürdüğü / tipi yasakladığı için SONRADAN yasadışı olması. Katılımcı bundan
 * yeniden beyan vererek çıkamaz — sayılar zaten mutabakata bağlandı ve adım 3'ten
 * sonra /declare ona kapalı.
 *
 * ⚠️ Not anahtarı burada `note`; /declare'de `ozelIzinNotu`. Karıştırmak notu sessizce
 *    düşürür (servis katmanı doğru anahtarı kullanıyor, bkz. projectService bölüm 12).
 * ⚠️ Başarısızlık çoğunlukla HTTP 200: "zaten bekleyen talep var" / "zaten geçerli
 *    izni var" 200 + result:false ile geliyor. Servis bunu Error'a çeviriyor.
 */
function OzelIzinTalepModal({ record, onClose, onSubmitted, isLive }) {
  const { t } = useTranslation("portal");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [violations, setViolations] = useState([]);

  const pb = record?.projectShell?.projeBeyani ?? null;
  const shellId = record?.projectShell?.id ?? null;

  async function submit() {
    if (!shellId) { setError(t("projeler.buStandIcinProjeKaydi")); return; }
    setBusy(true);
    setError(null);
    setViolations([]);
    try {
      await requestOzelIzin(shellId, note, { forceLive: isLive });
      onSubmitted();
    } catch (e) {
      setViolations(e.violations ?? []);
      setError(e.violations?.length ? null : e.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal isOpen centered toggle={busy ? undefined : onClose}>
      <ModalHeader toggle={busy ? undefined : onClose}>
        {t("projeler.projeYardimMerkezineIlet")}{record ? ` — ${record.standCode ?? record.standName}` : ""}
      </ModalHeader>
      <ModalBody>
        {error && <Alert color="danger">{error}</Alert>}
        {violations.length > 0 && (
          <KuralIhlalListesi
            violations={violations}
            title={t("projeler.buMaddelerIcinIstisnaTaninamaz")}
          />
        )}

        <div className="text-muted small mb-3">
          {t("projeler.kayitliBeyaninizBuFuarinKurallarina")}{" "}<span className="fw-semibold">{t("projeler.talebinizKararaBaglananaKadarProjeniz2")}</span>{t("projeler.birDenetmenOnaylarYaDa")}
        </div>

        {/* Beyandaki mevcut ihlaller — katılımcı neyin için izin istediğini görsün. */}
        <KuralIhlalListesi violations={pb?.violations} title={t("projeler.beyaninizdakiKuralIhlalleri")} />

        <FormGroup className="mb-0">
          <Label size="sm">{t("projeler.gerekceniz")}</Label>
          <Input
            type="textarea" rows={3} value={note} maxLength={OZEL_IZIN_NOT_MAX}
            onChange={(e) => setNote(e.target.value)}
            placeholder={t("projeler.ornBeyanimizKabulEdildiktenSonra")}
          />
          <div className="text-muted small mt-1">
            {t("projeler.denetmeninKarariVerirkenSayilarDisinda2", { length: note.length, OZEL_IZIN_NOT_MAX })}
          </div>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline onClick={onClose} disabled={busy}>{t("projeler.vazgec")}</Button>
        <Button color="warning" onClick={submit} disabled={busy}>
          {busy ? <Spinner size="sm" className="me-1" /> : <ShieldCheck size={14} className="me-1" />}
          {t("projeler.yardimMerkezineIlet")}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

const PAGE_SIZE = 10;

export default function FirmaProjelerListPage() {
  const { t: tx } = useTranslation("portal");
  const navigate = useNavigate();
  const { selectedFuarId } = useContext(MainContext);
  const portal = usePortal();
  const isLiveTestFuar = isLiveTestFuarId(selectedFuarId);
  // WAS (until #403): const firmaId = isLiveTestFuar ? TEST_DECORATOR_FIRMA_ID : getCurrentFirmaId();
  // WAS (until #713): const firmaId = isLiveTestFuar ? (portal?.firmaId ?? null) : getCurrentFirmaId();
  // null while /portal/context loads: the fetch effect below waits for it instead of asking for firma "null".
  const firmaId = portal?.firmaId ?? null;

  const [records, setRecords] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [reloadToken, setReloadToken] = useState(0);
  // record.id (mongo stand id) → açık revizyon sayısı, projectService.js'e standId
  // köprüsüyle bağlanır (bkz. dosya başı yorumu).
  const [openRevisionCounts, setOpenRevisionCounts] = useState({});
  // "Proje Beyanı" modalının hedef kaydı — null iken kapalı (bkz. CreateProjectModal).
  const [createModalRecord, setCreateModalRecord] = useState(null);
  // "Değişiklik Talebi" modalının hedef kaydı — 2026-08-25, bkz. ChangeRequestModal.
  const [changeRequestRecord, setChangeRequestRecord] = useState(null);
  // "Özel İzin İste" modalının hedef kaydı — 2026-08-28, bkz. OzelIzinTalepModal.
  const [ozelIzinRecord, setOzelIzinRecord] = useState(null);
  const [infoMsg, setInfoMsg] = useState(null);

  useEffect(() => { document.title = i18n.t("portal:projeler.projelerListesiFds"); }, []);

  useEffect(() => {
    if (!infoMsg) return;
    const t = setTimeout(() => setInfoMsg(null), 3000);
    return () => clearTimeout(t);
  }, [infoMsg]);

  // KURAL: fetch mantığı bilinçli olarak Effect içinde tanımlanır (üst seviye
  // useCallback olarak paylaşılmaz) — aksi halde react-hooks/set-state-in-effect
  // ihlali oluşur. Yenile butonu reloadToken'ı artırarak tetiklenir.
  useEffect(() => {
    // WAS (until #403): if (!selectedFuarId) return;
    if (!selectedFuarId || !firmaId) return;
    let ignore = false;

    async function run() {
      setLoading(true);
      setError(null);
      try {
        const data = await getFirmaProjeListesi({
          fuarId: selectedFuarId,
          // WAS (until #425): decoratorFirmaId: firmaId,
          // Canlı: firmanın HER rolde olduğu standlar (backend #423); satırlar rolünü taşır (firmaRolleri).
          // Mock dal decoratorFirmaId ile süzmeye devam eder.
          ...(isLiveTestFuar ? { firmaId } : { decoratorFirmaId: firmaId }),
          search,
          page: currentPage,
          limit: PAGE_SIZE,
          forceLive: isLiveTestFuar,
        });
        const fetchedRecords = data.records || [];
        if (!ignore) {
          // İLK BOYAMA roster'la: bilgi kutuları, İnşa İzni ve taahhütname kareleri
          // artık GET /standTalep/list satırından geliyor (bkz. missing-pills-guide.md),
          // köprüyü beklemeye gerek yok.
          setTotal(data.total || 0);
          setRecords(fetchedRecords);
          setLoading(false);
        }

        // İKİNCİ, ENGELLEMEYEN AŞAMA — köprüden geriye SADECE şunlar kaldı: belge
        // kutucuklarının okuduğu fileApprovals, Proje Beyanı kapısı (projeBeyani) ve
        // beyan modalının kök stand tipini aldığı projectShell, bir de açık revizyon
        // sayacı. Satır başına bir çağrı olduğu için listeyi bloke ETMEZ.
        const bridged = await Promise.all(
          fetchedRecords.map((r) => getProjectByStandId(r.standId, { forceLive: isLiveTestFuar }).catch(() => null))
        );
        if (!ignore) {
          const counts = {};
          fetchedRecords.forEach((r, i) => {
            // ⚠️ KAPANMAMIŞ revizyonlar (status !== 'resolved'), sadece OPEN olanlar
            // değil: dekoratör yanıtını gönderince revizyon ANSWERED'a geçiyor ve
            // sayaç sıfırlanırsa iş bitmiş gibi görünüyordu.
            counts[r.id] = (bridged[i]?.revisions || []).filter(isRevisionUnfinished).length;
          });
          setOpenRevisionCounts(counts);
          if (isLiveTestFuar) {
            setRecords(fetchedRecords.map((r, i) => mergeLiveProjectIntoRecord(r, bridged[i])));
          }
        }
      } catch (e) {
        if (!ignore) setError(e.message);
      } finally {
        if (!ignore) setLoading(false);
      }
    }

    run();
    return () => { ignore = true; };
  }, [selectedFuarId, firmaId, isLiveTestFuar, search, currentPage, reloadToken]);

  function handleSearchChange(e) {
    setSearch(e.target.value);
    setCurrentPage(1);
  }

  function goToStandDetail(record) {
    navigate(`/Firma/Anasayfa/${record.id}`);
  }

  // Revizyon uyarısı ve dört sayaç buraya gider: Proje Dosyaları sekmesi (revize
  // belgenin yeniden yüklendiği yer) + "Açık Revizyonlar" kartına scroll/vurgu.
  function goToRevisions(record) {
    navigate(`/Firma/Anasayfa/${record.id}?tab=files&focus=revizyonlar`);
  }

  function handleProjectCreated() {
    setCreateModalRecord(null);
    setInfoMsg(tx("projeler.projeBilgileriKaydedildi"));
    setReloadToken((t) => t + 1);
  }

  function handleChangeRequested() {
    setChangeRequestRecord(null);
    setInfoMsg(tx("projeler.degisiklikTalebinizIletildiIncelemeEkibi"));
    setReloadToken((t) => t + 1);
  }

  const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={tx("projeler.projelerListesi")} pageTitle={tx("projeler.firma")} />

        {error && <Alert color="danger">{error}</Alert>}
        {infoMsg && <Alert color="success">{infoMsg}</Alert>}
        {!selectedFuarId && <Alert color="info">{tx("projeler.buSayfayiGormekIcinOnce")}</Alert>}

        {selectedFuarId && (
          <Card className="mb-3">
            <CardBody>
              <Row className="align-items-center g-2">
                <Col md="8">
                  <Input
                    type="text"
                    placeholder={tx("projeler.standSalonVeyaFirmaAra")}
                    value={search}
                    onChange={handleSearchChange}
                    disabled={loading}
                  />
                </Col>
                <Col md="4" className="text-end">
                  <Button
                    color="secondary" outline size="sm"
                    onClick={() => setReloadToken((t) => t + 1)}
                    disabled={loading}
                  >
                    <RefreshCw size={14} className="me-1" />{" "}{tx("common:yenile")}
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
        )}

        {loading && (
          <div className="text-center py-5">
            <Spinner color="primary" />
            <p className="mt-2">{tx("common:yukleniyor")}</p>
          </div>
        )}

        {!loading && selectedFuarId && records.length === 0 && (
          <Alert color="secondary">{tx("projeler.buFuardaSizeBagliStand")}</Alert>
        )}

        {!loading && records.map((record) => {
          const hasProject = record.projectDeclared !== false;
          // #425 / #424: proje yazma işlemleri (beyan, beyanı düzenle, değişiklik talebi, özel izin isteği)
          // standın Dekoratörüne aittir — backend de böyle (PortalService.projeErisimi: Katılımcı projeyi
          // salt okunur izler). Satırın rolü bilinmiyorsa (mock / eski çağrı) eski davranış: Dekoratör.
          const dekoratorMu = standdaDekorator(record);

          if (!hasProject) {
            // Canlı köprüde "proje beyanı yok" iki farklı durumu kapsar — staff
            // henüz Proje Beyanı adım 1'i (kayıt + kök stand tipi) hiç açmadıysa
            // (projectShell === null) dekoratörün beyan edecek bir şeyi yok, bu
            // yüzden buton devre dışı: gerçek akışta önce staff kaydı açar (bkz.
            // FE-ProjectController-beyani-revisions-guide.md bölüm A / Management
            // tarafı StandOverviewDetailPage.jsx). Mock modda projectShell hiç
            // set edilmiyor (undefined) — eski "her zaman beyan edilebilir" akışı
            // orada değişmeden kalır.
            const shellMissing = isLiveTestFuar && record.projectShell === null;
            return (
              <Card key={record.id} className="mb-3 border border-warning">
                <CardBody>
                  <Row className="align-items-center g-3">
                    <Col md="auto">
                      <StandKodKutusu stand={record} color={NEUTRAL_GRAY} badgeTitle={tx("projeler.dekorasyonTipi")} />
                    </Col>

                    <Col md={2}>
                      <div className="fw-bold fs-5">{record.firmaShortName || record.firmaName || <span className="text-muted">-</span>}</div>
                      <div className="text-muted small">{record.dekoratorFirmaName || record.salonName}</div>
                      <StandRolRozeti record={record} className="d-block mt-1" />
                    </Col>

                    <Col className="text-muted d-flex align-items-center">
                      <Handshake size={16} className="me-2 flex-shrink-0" />
                      {shellMissing
                        ? tx("projeler.buStandIcinProjeKaydi2")
                        : tx("projeler.buStandIcinHenuzProje")}
                    </Col>

                    <Col md="auto" className="ms-auto mt-2 mt-md-0">
                      {/* WAS (until #425): düğme her satırda göründü (Katılımcı satırında da). */}
                      {dekoratorMu && (
                        <Button
                          color="warning" size="sm"
                          disabled={shellMissing}
                          title={shellMissing ? tx("projeler.projeKaydiStaffTarafindanAcilmadan") : undefined}
                          onClick={() => setCreateModalRecord(record)}
                        >
                          <Upload size={14} className="me-1" />{tx("projeler.projeBeyaniYap")}
                        </Button>
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            );
          }

          // İnşa İzni: canlıda backend'in dört durumlu cevabı (statusId 1 "Gerek yok" /
          // 4 "Verildi" / 7 "Nehir İSGM uygun gördü" = izin var), mock'ta eski belge
          // sayımı. Artık requiredCount/approvedCount'tan TÜRETİLMİYOR.
          const izinVar = record.constructionPermit
            ? CONSTRUCTION_PERMIT_GRANTED_STATUS_IDS.includes(record.constructionPermit.statusId)
            : (record.constructionPermitGranted ?? (record.requiredCount > 0 && record.approvedCount === record.requiredCount));

          return (
            <Card key={record.id} className="mb-3">
              <CardBody>
                <Row className="align-items-center g-3">
                  <Col md="auto">
                    <StandKodKutusu
                      stand={record}
                      color={izinVar ? STATUS_HEX.success : STATUS_HEX.danger}
                      onClick={() => goToStandDetail(record)}
                      hint={tx("projeler.detaylar")}
                      badgeTitle={tx("projeler.dekorasyonTipi")}
                    />
                  </Col>

                  <Col md={2}>
                    <div className="fw-bold fs-5">{record.firmaShortName || record.firmaName || <span className="text-muted">-</span>}</div>
                    <div className="text-muted small">{record.dekoratorFirmaName || record.salonName}</div>
                    <StandRolRozeti record={record} className="d-block mt-1" />
                  </Col>

                  <Col md="auto">
                    <div className="d-flex align-items-stretch flex-wrap gap-3">
                      {/* Gri bilgi kutularının SOLUNDA — kartın en yüksek sesli
                          öğesi olması istendi (2026-09-04). */}
                      <RevizyonUyarisi
                        count={openRevisionCounts[record.id]}
                        onClick={() => goToRevisions(record)}
                      />
                      <div className="d-flex align-items-center">
                        <StandInfoGrid stand={record} />
                      </div>
                      <VDivider />
                      <ProjeStatusTiles record={record} isLive={isLiveTestFuar} />
                      <VDivider />
                      <TaahhutnameTiles record={record} />
                    </div>
                  </Col>

                  <Col md="auto" className="d-flex align-items-center gap-3 ms-auto mt-2 mt-md-0">
                    <ProjeSayacStack
                      record={record}
                      openRevisionCount={openRevisionCounts[record.id]}
                    />
                    <OzelIzinDurumu
                      pb={record.projectShell?.projeBeyani}
                      // WAS (until #425): onRequest={() => setOzelIzinRecord(record)}
                      onRequest={dekoratorMu ? () => setOzelIzinRecord(record) : undefined}
                    />
                    {/* Beyan kabul edilene (Sistem Ataması) kadar dekoratör beyanını
                        serbestçe yeniden yapabilir; kabul edildikten SONRA /declare
                        400 döner ve beyanı değiştirmenin tek yolu bir değişiklik
                        talebidir (bkz. docs/guides/FE-Revisions-and-KVKK-update-guide.md
                        "POST /{id}/declare refuses once staff have accepted").
                        Hata mesajı emniyet ağı, UX değil — buton burada dallanır. */}
                    {/* #425: Katılımcı satırında yazma düğmeleri yok (WAS: her satırda). */}
                    {!dekoratorMu ? null : record.projectShell?.projeBeyani?.systemAssigned === true ? (
                      <Button
                        color="warning" outline size="sm"
                        onClick={() => setChangeRequestRecord(record)}
                        title={tx("projeler.beyaninizKabulEdildiDegisiklikIcin")}
                      >
                        <FileEdit size={14} className="me-1" />{tx("projeler.degisiklikTalebi")}
                      </Button>
                    ) : record.projectShell?.projeBeyani?.declared === true ? (
                      <Button
                        color="secondary" outline size="sm"
                        onClick={() => setCreateModalRecord(record)}
                        title={tx("projeler.beyaninizHenuzKabulEdilmediSerbestce")}
                      >
                        <FileEdit size={14} className="me-1" />{tx("projeler.beyaniDuzenle")}
                      </Button>
                    ) : null}
                    <Button
                      color="info" outline size="sm"
                      onClick={() => goToStandDetail(record)}
                    >
                      <Eye size={14} className="me-1" />{tx("projeler.detaylar")}
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          );
        })}

        <CreateProjectModal
          key={createModalRecord?.id ?? "closed"}
          record={createModalRecord}
          onClose={() => setCreateModalRecord(null)}
          onCreated={handleProjectCreated}
          isLive={isLiveTestFuar}
          fuarId={selectedFuarId}
        />

        <ChangeRequestModal
          key={changeRequestRecord?.id ?? "cr-closed"}
          record={changeRequestRecord}
          onClose={() => setChangeRequestRecord(null)}
          onSubmitted={handleChangeRequested}
          isLive={isLiveTestFuar}
        />

        {ozelIzinRecord && (
          <OzelIzinTalepModal
            key={`ozelizin-${ozelIzinRecord.id}`}
            record={ozelIzinRecord}
            isLive={isLiveTestFuar}
            onClose={() => setOzelIzinRecord(null)}
            onSubmitted={() => { setOzelIzinRecord(null); setReloadToken((t) => t + 1); }}
          />
        )}

        {!loading && records.length > 0 && totalPages > 1 && (
          <div className="d-flex justify-content-center p-3">
            <Pagination>
              <PaginationItem disabled={currentPage === 1}>
                <PaginationLink onClick={() => setCurrentPage(1)}>{tx("projeler.ilk")}</PaginationLink>
              </PaginationItem>
              {Array.from({ length: totalPages }, (_, i) => (
                <PaginationItem key={i} active={i + 1 === currentPage}>
                  <PaginationLink onClick={() => setCurrentPage(i + 1)}>{i + 1}</PaginationLink>
                </PaginationItem>
              ))}
              <PaginationItem disabled={currentPage >= totalPages}>
                <PaginationLink onClick={() => setCurrentPage(totalPages)}>{tx("projeler.son")}</PaginationLink>
              </PaginationItem>
            </Pagination>
          </div>
        )}

        {!loading && records.length > 0 && (
          <div className="text-center text-muted small p-3">
            <p>{tx("projeler.sayfaToplamStand", { currentPage, totalPages, total })}</p>
          </div>
        )}
      </Container>
    </div>
  );
}
